<template>
    <div class="app-container">
        <!-- 01 顶部导航栏 -->
        <header class="glass-header">
            <div class="logo-section" @click="scrollToTop">
                <img src="../assets/images/logo.png" @click="jumpRouter({router:'/home'})" alt="宠医客AI Logo" class="logo-img" />
                <img src="../assets/images/CTlogo.png" style="margin-left: 20px;" alt="宠医客AI Logo" class="logo-img" />
            </div>

            <nav ref="topNav" class="nav-menu">
                <div ref="navSlider" class="nav-slider"></div>

                <a href="#overview" @click.prevent="scrollToSection('overview')" class="nav-item">产品介绍</a>
                <a href="#feature-sysA" @click.prevent="scrollToSection('feature-sysA')" class="nav-item">功能亮点</a>
                <a href="#audience" @click.prevent="scrollToSection('audience')" class="nav-item">适用人群</a>
                <a href="#pricing" @click.prevent="scrollToSection('pricing')" class="nav-item">价格方案</a>
                <a href="#faq" @click.prevent="scrollToSection('faq')" class="nav-item">常见问题</a>
            </nav>
            <div id="header-user-area">
                <button v-if="!isLoggedIn" id="headerLoginBtn" @click="loginBox()" class="login-btn">
                    立即登录
                </button>
                <div v-else class="user-info">
                    <div class="phone-display orderBtn" @click="dialogVisible = true">订单记录</div>
                    <div class="phone-display">
                        <div class="user-icon"><svg xmlns="http://www.w3.org/2000/svg" color="#1066A9" width="14"
                                height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="user" aria-hidden="true"
                                class="lucide lucide-user w-3.5 h-3.5 text-brand-600">
                                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg></div>
                        {{ maskedPhone }}
                    </div>
                    <button id="logoutBtn" class="logout-btn" @click="handleLogout">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            data-lucide="log-out" aria-hidden="true" class="lucide lucide-log-out w-3.5 h-3.5">
                            <path d="m16 17 5-5-5-5"></path>
                            <path d="M21 12H9"></path>
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        </svg>退出
                    </button>
                </div>
            </div>
        </header>

        <!-- 02 首屏 Banner -->
        <section class="hero-section">
            <div class="bg-blur brand-blur"></div>
            <div class="bg-blur sysA-blur"></div>

            <div class="hero-content">
                <div class="feature-tags">
                    <span class="tag">零设备依赖</span>
                    <span class="tag">真实病例训练</span>
                    <span class="tag">AI评阅反馈</span>
                    <span class="tag">电脑端在线学习</span>
                    <span class="tag">操作与诊断双系统</span>
                </div>

                <h1 class="hero-title">
                    小动物CT影像实训系统
                </h1>
                <h2 class="hero-subtitle">
                    在线完成CT扫描操作、病例阅片与诊断报告训练
                </h2>
                <p class="hero-description">
                    面向小动物医生、影像科医生、实习医生及教学机构，提供小动物CT检查流程实训与影像诊断思维训练。无需真实CT设备，不依赖活体动物，也能在电脑端反复练习CT操作流程、病例分析和报告书写。
                </p>

                <div class="hero-buttons">
                    <button class="btn-primary" @click="openPurchaseModal()">
                        立即购买 <svg t="1782442634245" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="8149" width="20" height="20">
                            <path
                                d="M754.752 480H160a32 32 0 1 0 0 64h594.752L521.344 777.344a32 32 0 0 0 45.312 45.312l288-288a32 32 0 0 0 0-45.312l-288-288a32 32 0 1 0-45.312 45.312z"
                                p-id="8150" fill="#ffffff"></path>
                        </svg>
                    </button>
                    <a v-show="UserVip.length == 0 " href="#pricing" class="btn-secondary" @click.prevent="handleSecondaryBtnClick">
                        查看价格方案
                    </a>
                    <a v-for="(item, index) in UserVip" :key="index" href="#" class="btn-secondary" @click.prevent="jumpSystem(item)">
                        进入系统
                        <div :class="item.vip_type==1?'systemBtn systemBtn2':'systemBtn '">
                            {{ item.vip_type==1?'CT成像数字孪生系统实训':'CT图像诊断思维训练系统' }}
                        </div>
                    </a>
                </div>
            </div>

            <div class="hero-images">
                <div class="image-stack">
                    <div class="image-card card-3">
                        <div class="image-placeholder">
                            <img class="petCtTrainingLandingImg" src="../assets/images/petCtTrainingLandingImg3.png" alt="">
                        </div>
                        <div class="card-label label-sysB">AI评阅与报告</div>
                    </div>
                    <div class="image-card card-2">
                        <div class="image-placeholder">
                            <img class="petCtTrainingLandingImg" src="../assets/images/petCtTrainingLandingImg2.png" alt="">
                        </div>
                        <div class="card-label label-default">真实病例库阅片</div>
                    </div>
                    <div class="image-card card-1">
                        <div class="image-placeholder">
                            <img class="petCtTrainingLandingImg" src="../assets/images/petCtTrainingLandingImg1.png" alt="">
                        </div>
                        <div class="card-label label-sysA">3D虚拟CT实操</div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 03 两个系统介绍 -->
        <section id="overview" class="section overview-section">
            <div class="section-header">
                <h2>两个系统，覆盖小动物CT学习核心能力</h2>
                <p>从检查操作到诊断报告，帮助学员建立完整的小动物CT实训路径。</p>
            </div>

            <div class="systems-grid">
                <div class="system-card system-a">
                    <div class="card-accent accent-a"></div>
                    <div class="card-glow glow-a"></div>

                    <span class="system-badge badge-a">练操作</span>
                    <h3 class="system-title">CT成像数字孪生系统实训</h3>
                    <p class="system-description">通过虚拟CT检查场景，还原小动物CT检查全流程，训练设备巡检、动物接诊、麻醉监护、扫描摆位、参数设置、图像采集与后处理等操作能力。</p>

                    <div class="training-content">
                        <h4 class="content-title"><svg xmlns="http://www.w3.org/2000/svg" color="#0d9488" width="16"
                                height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="target" aria-hidden="true"
                                class="lucide lucide-target w-4 h-4 text-sysB-500">
                                <circle cx="12" cy="12" r="10"></circle>
                                <circle cx="12" cy="12" r="6"></circle>
                                <circle cx="12" cy="12" r="2"></circle>
                            </svg> 核心训练内容</h4>
                        <ul class="content-list">
                            <li>
                                <div class="dot dot-a"></div>设备日常巡检
                            </li>
                            <li>
                                <div class="dot dot-a"></div>动物接诊与检查准备
                            </li>
                            <li>
                                <div class="dot dot-a"></div>麻醉诱导与生命监护
                            </li>
                            <li>
                                <div class="dot dot-a"></div>扫描摆位与参数设置
                            </li>
                            <li>
                                <div class="dot dot-a"></div>CT图像采集
                            </li>
                            <li>
                                <div class="dot dot-a"></div>图像后处理
                            </li>
                            <li class="full-width">
                                <div class="dot dot-a"></div>麻醉复苏与设备复位
                            </li>
                        </ul>
                    </div>

                    <div class="suitable-box">
                        <h4>适合对象：</h4>
                        <p>刚接触CT检查流程的医生、小动物医院影像科实习医生、动物医学相关专业学生、需要规范影像操作流程的机构。</p>
                    </div>

                    <button class="btn-outline btn-outline-a" @click="scrollToSection('feature-sysA')">
                        了解操作实训 <svg xmlns="http://www.w3.org/2000/svg" color="#0d9488" width="17" height="17"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="arrow-down" aria-hidden="true"
                            class="lucide lucide-arrow-down w-4 h-4">
                            <path d="M12 5v14"></path>
                            <path d="m19 12-7 7-7-7"></path>
                        </svg>
                    </button>
                </div>

                <div class="system-card system-b">
                    <div class="card-accent accent-b"></div>
                    <div class="card-glow glow-b"></div>

                    <span class="system-badge badge-b">练诊断</span>
                    <h3 class="system-title">CT图像诊断思维训练系统</h3>
                    <p class="system-description">基于小动物真实CT/MR临床病例，提供病例调阅、影像分析、测量工具、报告书写、AI评阅和标准报告对照，训练完整影像诊断思维。</p>

                    <div class="training-content">
                        <h4 class="content-title"><svg xmlns="http://www.w3.org/2000/svg" color="#4f46e5" width="16"
                                height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="target" aria-hidden="true"
                                class="lucide lucide-target w-4 h-4 text-sysB-500">
                                <circle cx="12" cy="12" r="10"></circle>
                                <circle cx="12" cy="12" r="6"></circle>
                                <circle cx="12" cy="12" r="2"></circle>
                            </svg> 核心训练内容</h4>
                        <ul class="content-list">
                            <li>
                                <div class="dot dot-b"></div>真实CT/MR病例调阅
                            </li>
                            <li>
                                <div class="dot dot-b"></div>CT值/长度/角度测量
                            </li>
                            <li>
                                <div class="dot dot-b"></div>MPR多平面重建
                            </li>
                            <li>
                                <div class="dot dot-b"></div>MIP最大密度投影
                            </li>
                            <li>
                                <div class="dot dot-b"></div>3D可视化重建
                            </li>
                            <li>
                                <div class="dot dot-b"></div>诊断报告书写
                            </li>
                            <li class="full-width">
                                <div class="dot dot-b"></div>AI评阅与标准报告对照
                            </li>
                        </ul>
                    </div>

                    <div class="suitable-box">
                        <h4>适合对象：</h4>
                        <p>想提升阅片能力的临床医生、小动物影像科医生、需要积累病例经验的年轻医生、需要进行影像考核的教学机构。</p>
                    </div>

                    <button class="btn-outline btn-outline-b" @click="scrollToSection('feature-sysB')">
                        了解诊断训练 <svg xmlns="http://www.w3.org/2000/svg" color="#4f46e5" width="17" height="17"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="arrow-down" aria-hidden="true"
                            class="lucide lucide-arrow-down w-4 h-4">
                            <path d="M12 5v14"></path>
                            <path d="m19 12-7 7-7-7"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </section>

        <!-- 04 用户痛点区 -->
        <section class="section pain-points-section">
            <div class="section-header centered">
                <h2>小动物CT学习，难的不只是"看懂一张片"</h2>
            </div>

            <div class="pain-points-grid">
                <div class="pain-point-card">
                    <div class="icon-box icon-red">
                        <svg xmlns="http://www.w3.org/2000/svg" color="#ef4444" width="24" height="24" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="alert-triangle" aria-hidden="true"
                            class="lucide lucide-alert-triangle text-red-500 w-6 h-6">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
                            <path d="M12 9v4"></path>
                            <path d="M12 17h.01"></path>
                        </svg>
                    </div>
                    <h3>真实设备练习机会少</h3>
                    <p>CT设备成本高，临床环境中很难让初学者反复练习完整操作流程。</p>
                </div>
                <div class="pain-point-card">
                    <div class="icon-box icon-orange">
                        <svg xmlns="http://www.w3.org/2000/svg" color="#f97316" width="24" height="24" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="heart-pulse" aria-hidden="true"
                            class="lucide lucide-heart-pulse text-orange-500 w-6 h-6">
                            <path
                                d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5">
                            </path>
                            <path d="M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"></path>
                        </svg>
                    </div>
                    <h3>活体训练风险高</h3>
                    <p>小动物CT涉及麻醉、摆位、扫描参数等环节，真实操作存在动物安全和医疗风险。</p>
                </div>
                <div class="pain-point-card">
                    <div class="icon-box icon-brand">
                        <svg xmlns="http://www.w3.org/2000/svg" color="#1066a9" width="24" height="24" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="hourglass" aria-hidden="true"
                            class="lucide lucide-hourglass text-brand-600 w-6 h-6">
                            <path d="M5 22h14"></path>
                            <path d="M5 2h14"></path>
                            <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"></path>
                            <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"></path>
                        </svg>
                    </div>
                    <h3>病例积累周期长</h3>
                    <p>影像诊断能力依赖大量病例训练，仅靠课堂学习和零散临床病例，很难快速形成系统思路。</p>
                </div>
                <div class="pain-point-card">
                    <div class="icon-box icon-purple">
                        <svg xmlns="http://www.w3.org/2000/svg" color="#a855f7" width="24" height="24" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="file-x-2" aria-hidden="true"
                            class="lucide lucide-file-x-2 text-purple-500 w-6 h-6">
                            <path
                                d="M11 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5">
                            </path>
                            <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                            <path d="m15 17 5 5"></path>
                            <path d="m20 17-5 5"></path>
                        </svg>
                    </div>
                    <h3>报告书写不规范</h3>
                    <p>很多医生能发现异常，但难以用规范术语和清晰结构完成高质量诊断报告。</p>
                </div>
            </div>
        </section>

        <!-- 05 功能详解一：CT成像数字孪生系统实训 -->
        <section id="feature-sysA" class="section feature-sysA-section">
            <div class="section-bg skew-bg-a"></div>
            <div class="section-header left-aligned">
                <span class="section-label label-sysA">CT成像数字孪生系统实训</span>
                <h2>像在真实CT室一样，完成一次小动物CT检查训练</h2>
                <p>从设备准备到动物复苏，完整模拟小动物CT检查流程，让高风险操作可以在虚拟环境中反复练习。</p>
            </div>

            <div class="feature-content">
                <div class="workflow-panel">
                    <h3 class="workflow-title">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            data-lucide="git-merge" aria-hidden="true"
                            class="lucide lucide-git-merge text-sysA-600 w-5 h-5">
                            <circle cx="18" cy="18" r="3"></circle>
                            <circle cx="6" cy="6" r="3"></circle>
                            <path d="M6 21V9a9 9 0 0 0 9 9"></path>
                        </svg>
                        实训工作流
                    </h3>
                    <div class="workflow-steps">
                        <div class="step">
                            <div class="step-dot"></div>
                            <h4>登录系统 & 设备巡检</h4>
                        </div>
                        <div class="step">
                            <div class="step-dot"></div>
                            <h4>动物接诊</h4>
                        </div>
                        <div class="step">
                            <div class="step-dot"></div>
                            <h4>麻醉诱导 & 气管插管</h4>
                        </div>
                        <div class="step step-highlight">
                            <div class="step-dot highlighted"></div>
                            <h4>扫描摆位 & 参数设定</h4>
                            <p class="step-note">核心操作环节</p>
                        </div>
                        <div class="step step-highlight">
                            <div class="step-dot highlighted"></div>
                            <h4>影像采集 & 图像后处理</h4>
                            <p class="step-note">核心操作环节</p>
                        </div>
                        <div class="step">
                            <div class="step-dot"></div>
                            <h4>麻醉复苏 & 设备复位</h4>
                        </div>
                    </div>
                </div>

                <div class="features-grid">
                    <div class="feature-item">
                        <div class="feature-icon icon-sysA"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="box" aria-hidden="true"
                                class="lucide lucide-box">
                                <path
                                    d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z">
                                </path>
                                <path d="m3.3 7 8.7 5 8.7-5"></path>
                                <path d="M12 22V12"></path>
                            </svg></div>
                        <h4>全真虚拟场景</h4>
                        <p>系统构建药物准备区、麻醉监控区、CT设备操作区、动物模型训练区，模拟小动物CT检查中的关键场景。</p>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon icon-sysA"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="list-checks" aria-hidden="true"
                                class="lucide lucide-list-checks">
                                <path d="M13 5h8"></path>
                                <path d="M13 12h8"></path>
                                <path d="M13 19h8"></path>
                                <path d="m3 17 2 2 4-4"></path>
                                <path d="m3 7 2 2 4-4"></path>
                            </svg></div>
                        <h4>标准化流程引导</h4>
                        <p>围绕技师登录、球管预热、空气校正、动物接诊、麻醉诱导、扫描摆位、参数设置等步骤，帮助学员掌握规范操作流程。</p>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon icon-sysA"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="activity" aria-hidden="true"
                                class="lucide lucide-activity">
                                <path
                                    d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2">
                                </path>
                            </svg></div>
                        <h4>麻醉与生命体征联动</h4>
                        <p>麻醉深度、扫描参数等设置会影响图像质量和动物生命体征，帮助学员理解临床操作与检查结果之间的关系。</p>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon icon-sysA"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="sliders-horizontal"
                                aria-hidden="true" class="lucide lucide-sliders-horizontal">
                                <path d="M10 5H3"></path>
                                <path d="M12 19H3"></path>
                                <path d="M14 3v4"></path>
                                <path d="M16 17v4"></path>
                                <path d="M21 12h-9"></path>
                                <path d="M21 19h-5"></path>
                                <path d="M21 5h-7"></path>
                                <path d="M8 10v4"></path>
                                <path d="M8 12H3"></path>
                            </svg></div>
                        <h4>图像采集与后处理</h4>
                        <p>支持图像缩放、移动、窗宽窗位调节、黑白反色、直方图均衡化等操作，贴近真实影像后处理流程。</p>
                    </div>
                    <div class="feature-item full-width bg-light">
                        <h4><svg xmlns="http://www.w3.org/2000/svg" color="#14b8a6" width="18" height="18"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="repeat" aria-hidden="true"
                                class="lucide lucide-repeat w-5 h-5 text-sysA-500">
                                <path d="m17 2 4 4-4 4"></path>
                                <path d="M3 11v-1a4 4 0 0 1 4-4h14"></path>
                                <path d="m7 22-4-4 4-4"></path>
                                <path d="M21 13v1a4 4 0 0 1-4 4H3"></path>
                            </svg> 可重复训练</h4>
                        <p>复杂、高风险、低频次的操作，可在虚拟环境中多次练习，大幅降低真实临床试错成本，保障动物福利。</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 06 功能详解二：CT图像诊断思维训练系统 -->
        <section id="feature-sysB" class="section feature-sysB-section">
            <div class="section-bg skew-bg-b"></div>

            <div class="section-header right-aligned">
                <span class="section-label label-sysB">CT图像诊断思维训练系统</span>
                <h2>从病例调阅到报告书写，训练完整影像诊断思维</h2>
                <p>不是单纯看病例，而是让学员完成"阅片、分析、诊断、写报告、接受评价"的完整训练闭环。</p>
            </div>

            <div class="feature-content reverse">
                <div class="right-panel">
                    <div class="cycle-flow">
                        <div class="flow-step">
                            <div class="step-number">1</div>病例选择
                        </div>
                        <i class="icon-arrow-right flow-arrow"></i>
                        <div class="flow-step">
                            <div class="step-number">2</div>阅片分析
                        </div>
                        <i class="icon-arrow-right flow-arrow"></i>
                        <div class="flow-step">
                            <div class="step-number">3</div>报告书写
                        </div>
                        <i class="icon-arrow-right flow-arrow"></i>
                        <div class="flow-step">
                            <div class="step-number">4</div>AI评阅
                        </div>
                        <i class="icon-arrow-right flow-arrow"></i>
                        <div class="flow-step">
                            <div class="step-number">5</div>标准报告对照
                        </div>
                        <i class="icon-arrow-right flow-arrow"></i>
                        <div class="flow-step highlight">
                            <div class="step-number highlighted">6</div>训练记录
                        </div>
                    </div>

                    <div class="image-mockup">
                        <div class="mockup-content">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                data-lucide="image" aria-hidden="true" class="lucide lucide-image w-16 h-16 mb-4">
                                <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
                                <circle cx="9" cy="9" r="2"></circle>
                                <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                            </svg> -->
                            <img class="petCtTrainingLandingImg" style=" width: 100%;" src="../assets/images/petCtTrainingLandingImg4.png" alt="">
                        </div>
                        <div class="mockup-overlay">
                            <div>
                                <span class="overlay-badge">MPR / VR / MIP三维影像重建</span>
                                <p>内置多维影像分析工具，所见即所得</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="features-grid">
                    <div class="feature-item">
                        <div class="feature-icon icon-white"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="database" aria-hidden="true"
                                class="lucide lucide-database">
                                <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                                <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
                                <path d="M3 12A9 3 0 0 0 21 12"></path>
                            </svg></i></div>
                        <h4>真实病例库</h4>
                        <p>内置 1000+ 小动物真实 CT/MR 临床病例，覆盖多部位、多疾病类型，支持学员进行系统化病例训练。</p>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon icon-white"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="ruler" aria-hidden="true"
                                class="lucide lucide-ruler">
                                <path
                                    d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z">
                                </path>
                                <path d="m14.5 12.5 2-2"></path>
                                <path d="m11.5 9.5 2-2"></path>
                                <path d="m8.5 6.5 2-2"></path>
                                <path d="m17.5 15.5 2-2"></path>
                            </svg></div>
                        <h4>专业阅片工具</h4>
                        <p>支持 CT值测量、长度测量、角度测量、面积分析等操作，帮助学员对病灶进行量化判断。</p>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon icon-white"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="layers" aria-hidden="true"
                                class="lucide lucide-layers">
                                <path
                                    d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z">
                                </path>
                                <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path>
                                <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path>
                            </svg></div>
                        <h4>多维影像分析</h4>
                        <p>提供 MPR 多平面重建、MIP 最大密度投影、3D 可视化重建等工具，帮助学员从多角度分析影像信息。</p>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon icon-white"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="file-text" aria-hidden="true"
                                class="lucide lucide-file-text">
                                <path
                                    d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                                </path>
                                <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                                <path d="M10 9H8"></path>
                                <path d="M16 13H8"></path>
                                <path d="M16 17H8"></path>
                            </svg></div>
                        <h4>诊断报告训练</h4>
                        <p>学员需要基于病例影像完成诊断报告，训练影像征象描述、诊断逻辑表达和报告结构规范。</p>
                    </div>
                    <div class="feature-item">
                        <h4><svg xmlns="http://www.w3.org/2000/svg" color="#4f46e5" width="20" height="20"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="sparkles" aria-hidden="true"
                                class="lucide lucide-sparkles w-5 h-5 text-sysB-600">
                                <path
                                    d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z">
                                </path>
                                <path d="M20 2v4"></path>
                                <path d="M22 4h-4"></path>
                                <circle cx="4" cy="20" r="2"></circle>
                            </svg> AI评阅反馈</h4>
                        <p>系统可从描述完整性、术语准确性、诊断逻辑性等维度对报告进行评价，明确问题并给出改进方向。</p>
                    </div>
                    <div class="feature-item">
                        <h4><svg xmlns="http://www.w3.org/2000/svg" color="#10b981" width="20" height="20"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="file-check" aria-hidden="true"
                                class="lucide lucide-file-check w-5 h-5 text-emerald-500">
                                <path
                                    d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                                </path>
                                <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                                <path d="m9 15 2 2 4-4"></path>
                            </svg> 标准报告对照</h4>
                        <p>训练完成后可对照标准报告，帮助学员发现遗漏点、表达问题和诊断思路偏差。</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 07 使用场景区 -->
        <section id="audience" class="section audience-section">
            <div class="section-header centered">
                <h2>适用于个人医生提升与小动物医院培训</h2>
            </div>
            <div class="audience-grid">
                <div class="audience-card">
                    <div class="card-header">
                        <h3>个人医生能力提升</h3>
                        <p>临床医生 / 年轻医生</p>
                    </div>
                    <ul class="benefit-list">
                        <li><svg xmlns="http://www.w3.org/2000/svg" color="#10b981" width="18" height="18"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                class="lucide lucide-check w-4 h-4 text-emerald-500 mt-0.5 shrink-0">
                                <path d="M20 6 9 17l-5-5"></path>
                            </svg> 学习CT检查流程</li>
                        <li><svg xmlns="http://www.w3.org/2000/svg" color="#10b981" width="18" height="18"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                class="lucide lucide-check w-4 h-4 text-emerald-500 mt-0.5 shrink-0">
                                <path d="M20 6 9 17l-5-5"></path>
                            </svg> 提升阅片和诊断能力</li>
                        <li><svg xmlns="http://www.w3.org/2000/svg" color="#10b981" width="18" height="18"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                class="lucide lucide-check w-4 h-4 text-emerald-500 mt-0.5 shrink-0">
                                <path d="M20 6 9 17l-5-5"></path>
                            </svg> 规范诊断报告书写</li>
                    </ul>
                    <button class="btn-recommend" @click="highlightPricing('pricing-sysB')">
                        推荐购买诊断训练 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="arrow-right" aria-hidden="true"
                            class="lucide lucide-arrow-right w-4 h-4">
                            <path d="M5 12h14"></path>
                            <path d="m12 5 7 7-7 7"></path>
                        </svg>
                    </button>
                </div>
                <div class="audience-card">
                    <div class="card-header">
                        <h3>小动物医院内部培训</h3>
                        <p>有CT设备或影像科的医院</p>
                    </div>
                    <ul class="benefit-list">
                        <li><svg xmlns="http://www.w3.org/2000/svg" color="#10b981" width="18" height="18"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                class="lucide lucide-check w-4 h-4 text-emerald-500 mt-0.5 shrink-0">
                                <path d="M20 6 9 17l-5-5"></path>
                            </svg> 降低新人实操风险</li>
                        <li><svg xmlns="http://www.w3.org/2000/svg" color="#10b981" width="18" height="18"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                class="lucide lucide-check w-4 h-4 text-emerald-500 mt-0.5 shrink-0">
                                <path d="M20 6 9 17l-5-5"></path>
                            </svg> 统一检查操作流程</li>
                        <li><svg xmlns="http://www.w3.org/2000/svg" color="#10b981" width="18" height="18"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                class="lucide lucide-check w-4 h-4 text-emerald-500 mt-0.5 shrink-0">
                                <path d="M20 6 9 17l-5-5"></path>
                            </svg> 提升医院报告质量</li>
                    </ul>
                    <button class="btn-recommend" @click="highlightPricing('pricing-combo')">
                        推荐购买打包产品 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="arrow-right" aria-hidden="true"
                            class="lucide lucide-arrow-right w-4 h-4">
                            <path d="M5 12h14"></path>
                            <path d="m12 5 7 7-7 7"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </section>

        <!-- 08 产品优势区 -->
        <section class="section advantages-section">
            <div class="section-header centered white-text">
                <h2>让小动物CT训练更安全、更标准、更可重复</h2>
            </div>
            <div class="advantages-grid">
                <div class="advantage-card">
                    <svg xmlns="http://www.w3.org/2000/svg" color="#569fd2" width="32" height="32" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        data-lucide="piggy-bank" aria-hidden="true"
                        class="lucide lucide-piggy-bank w-8 h-8 text-brand-400 mb-4">
                        <path
                            d="M11 17h3v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a3.16 3.16 0 0 0 2-2h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1a5 5 0 0 0-2-4V3a4 4 0 0 0-3.2 1.6l-.3.4H11a6 6 0 0 0-6 6v1a5 5 0 0 0 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1z">
                        </path>
                        <path d="M16 10h.01"></path>
                        <path d="M2 8v1a2 2 0 0 0 2 2h1"></path>
                    </svg>
                    <h3>降低实训成本</h3>
                    <p>无需购买真实CT设备，不需持续投入麻醉药物、耗材和维护成本，适合长期使用。</p>
                </div>
                <div class="advantage-card">
                    <svg xmlns="http://www.w3.org/2000/svg" color="#569fd2" width="32" height="32" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        data-lucide="shield-check" aria-hidden="true"
                        class="lucide lucide-shield-check w-8 h-8 text-brand-400 mb-4">
                        <path
                            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z">
                        </path>
                        <path d="m9 12 2 2 4-4"></path>
                    </svg>
                    <h3>降低动物风险</h3>
                    <p>在虚拟环境中先完成流程练习，减少真实动物训练中的麻醉、操作和医疗风险。</p>
                </div>
                <div class="advantage-card">
                    <svg xmlns="http://www.w3.org/2000/svg" color="#569fd2" width="32" height="32" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        data-lucide="git-pull-request" aria-hidden="true"
                        class="lucide lucide-git-pull-request w-8 h-8 text-brand-400 mb-4">
                        <circle cx="18" cy="18" r="3"></circle>
                        <circle cx="6" cy="6" r="3"></circle>
                        <path d="M13 6h3a2 2 0 0 1 2 2v7"></path>
                        <line x1="6" x2="6" y1="9" y2="21"></line>
                    </svg>
                    <h3>训练流程完整</h3>
                    <p>覆盖CT检查操作、麻醉监护、扫描采集、图像后处理、病例诊断、报告书写与评价。</p>
                </div>
                <div class="advantage-card">
                    <svg xmlns="http://www.w3.org/2000/svg" color="#569fd2" width="32" height="32" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        data-lucide="files" aria-hidden="true" class="lucide lucide-files w-8 h-8 text-brand-400 mb-4">
                        <path d="M15 2h-4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8"></path>
                        <path d="M16.706 2.706A2.4 2.4 0 0 0 15 2v5a1 1 0 0 0 1 1h5a2.4 2.4 0 0 0-.706-1.706z"></path>
                        <path d="M5 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 1.732-1"></path>
                    </svg>
                    <h3>真实病例丰富</h3>
                    <p>内置大量小动物真实病例，帮助学员通过反复训练积累多部位、多疾病类型的经验。</p>
                </div>
                <div class="advantage-card">
                    <svg xmlns="http://www.w3.org/2000/svg" color="#569fd2" width="32" height="32" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        data-lucide="message-square-check" aria-hidden="true"
                        class="lucide lucide-message-square-check w-8 h-8 text-brand-400 mb-4">
                        <path
                            d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.7.7 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z">
                        </path>
                        <path d="m9 11 2 2 4-4"></path>
                    </svg>
                    <h3>反馈更加清晰</h3>
                    <p>AI评阅可对诊断报告进行多维度评价，帮助学员看到具体问题，方便机构教学管理。</p>
                </div>
                <div class="advantage-card">
                    <svg xmlns="http://www.w3.org/2000/svg" color="#569fd2" width="32" height="32" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        data-lucide="monitor-smartphone" aria-hidden="true"
                        class="lucide lucide-monitor-smartphone w-8 h-8 text-brand-400 mb-4">
                        <path d="M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8"></path>
                        <path d="M10 19v-3.96 3.15"></path>
                        <path d="M7 19h5"></path>
                        <rect width="6" height="10" x="16" y="12" rx="2"></rect>
                    </svg>
                    <h3>电脑端在线使用</h3>
                    <p>通过电脑端访问使用，操作界面更适合阅片、测量、报告书写和实训系统化管理。</p>
                </div>
            </div>
        </section>

        <!-- 09 价格方案区 -->
        <section id="pricing" class="section pricing-section">
            <div class="section-header centered">
                <h2>选择适合你的训练方案</h2>
                <p>可单独购买操作实训或诊断训练，也可选择打包产品，完整训练操作与诊断能力。</p>
            </div>
            <div class="pricing-grid">
                <div id="pricing-sysA" class="pricing-card" ref="pricingSysA">
                    <div class="card-top-accent accent-sysA"></div>
                    <div class="card-content">
                        <span class="price-badge badge-sysA">练CT操作流程</span>
                        <h3>CT成像数字孪生系统实训</h3>
                        <p class="price-description">适合学习CT设备操作、扫描流程、动物摆位、麻醉监护和图像采集。</p>
                    </div>
                    <div class="price-options">
                        <div class="price-row" v-for="(item, index) in productListA" :key="index"><span>{{ item.vip_duration
                        }}</span><span class="price"> {{ item.selling_price }}元</span></div>
                        <!-- <div class="price-row"><span>3个月</span><span class="price">328元</span></div> -->
                        <!-- <div class="price-row"><span>半年</span><span class="price">598元</span></div> -->
                    </div>
                    <div class="card-features">
                        <ul>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#14b8a6" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> CT检查虚拟场景</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#14b8a6" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> 设备巡检流程</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#14b8a6" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> 动物接诊与麻醉训练</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#14b8a6" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> 扫描摆位与参数设置</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#14b8a6" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> 图像采集与后处理训练</li>
                        </ul>
                    </div>
                    <button class="btn-buy btn-buy-sysA" @click="openPurchaseModal('sysA')">购买操作实训</button>
                </div>

                <div id="pricing-combo" class="pricing-card featured" ref="pricingCombo">
                    <div class="recommended-badge">
                        <span>推荐</span>
                    </div>
                    <div class="card-content">
                        <span class="price-badge badge-combo">操作 + 诊断完整训练</span>
                        <h3>打包产品</h3>
                        <p class="price-description">同时包含操作实训和诊断训练系统，适合系统学习小动物CT完整流程。</p>
                    </div>
                    <div class="price-options combo-options">
                        <!-- <div class="price-row"><span>1个月</span><span class="price price-brand">288元</span></div>
                        <div class="price-row"><span>3个月</span><span class="price price-brand">528元</span></div>
                        <div class="price-row"><span>半年</span><span class="price price-brand price-large">888元</span></div> -->
                        <div class="price-row" v-for="(item, index) in productListAB" :key="index"><span>{{
                            item.vip_duration }}</span><span class="price"> {{ item.selling_price }}元</span></div>

                    </div>
                    <div class="card-features">
                        <ul>
                            <li class="featured-feature"><svg xmlns="http://www.w3.org/2000/svg" color="#1066a9" width="16"
                                    height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle"
                                    aria-hidden="true"
                                    class="lucide lucide-check-circle w-4 h-4 text-brand-500 shrink-0 mt-0.5">
                                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                                    <path d="m9 11 3 3L22 4"></path>
                                </svg> 包含两大系统所有功能</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#1066a9" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> CT数字孪生操作实训</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#1066a9" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> 真实CT/MR病例训练</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#1066a9" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> 阅片测量工具</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#1066a9" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> 诊断报告书写 & AI评阅</li>
                        </ul>
                    </div>
                    <button class="btn-buy btn-buy-combo" @click="openPurchaseModal('combo')">购买打包产品</button>
                </div>

                <div id="pricing-sysB" class="pricing-card" ref="pricingSysB">
                    <div class="card-top-accent accent-sysB"></div>
                    <div class="card-content">
                        <span class="price-badge badge-sysB">练阅片诊断与报告</span>
                        <h3>CT图像诊断思维训练系统</h3>
                        <p class="price-description">适合提升病例调阅、影像分析、诊断推理和报告书写能力。</p>
                    </div>
                    <div class="price-options">
                        <!-- <div class="price-row"><span>3天体验</span><span class="price">9.9元</span></div>
                        <div class="price-row"><span>1个月</span><span class="price">128元</span></div>
                        <div class="price-row"><span>3个月</span><span class="price">258元</span></div>
                        <div class="price-row"><span>半年</span><span class="price">398元</span></div>
                        <div class="price-row"><span>1年</span><span class="price">698元</span></div> -->
                        <div class="price-row" v-for="(item, index) in productListB" :key="index"><span>{{ item.vip_duration
                        }}</span><span class="price"> {{ item.selling_price }}元</span></div>
                    </div>
                    <div class="card-features">
                        <ul>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#6366f1" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> 1000+真实CT/MR病例</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#6366f1" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> PACS病例调阅</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#6366f1" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> 各种专业测量工具</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#6366f1" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> MPR/MIP/3D重建</li>
                            <li><svg xmlns="http://www.w3.org/2000/svg" color="#6366f1" width="16" height="16"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" data-lucide="check" aria-hidden="true"
                                    class="lucide lucide-check w-4 h-4 text-brand-400 shrink-0 mt-0.5">
                                    <path d="M20 6 9 17l-5-5"></path>
                                </svg> 诊断报告书写与AI评阅</li>
                        </ul>
                    </div>
                    <button class="btn-buy btn-buy-sysB" @click="openPurchaseModal('sysB')">购买诊断训练</button>
                </div>
            </div>
        </section>

        <!-- 10 选择指南 -->
        <section class="section selection-guide">
            <h3 class="guide-title">不知道选哪个？按学习目标选择</h3>
            <div class="guide-grid">
                <div class="guide-card" @click="highlightPricing('pricing-sysB')">
                    <h4>我想先体验一下</h4>
                    <p class="guide-choice">选择：诊断训练系统 3天体验</p>
                    <p class="guide-desc">适合初次了解产品、想先体验病例训练和报告评阅的用户。</p>
                </div>
                <div class="guide-card" @click="highlightPricing('pricing-sysA')">
                    <h4>我想练CT检查操作</h4>
                    <p class="guide-choice choice-sysA">选择：数字孪生操作实训</p>
                    <p class="guide-desc">适合重点学习设备操作、扫描摆位、参数设置和CT检查流程的用户。</p>
                </div>
                <div class="guide-card" @click="highlightPricing('pricing-sysB')">
                    <h4>我想提升阅片能力</h4>
                    <p class="guide-choice choice-sysB">选择：诊断思维训练系统</p>
                    <p class="guide-desc">适合想积累病例、提升影像诊断思维、规范报告书写的用户。</p>
                </div>
                <div class="guide-card combo-guide" @click="highlightPricing('pricing-combo')">
                    <h4>我想系统学习CT</h4>
                    <p class="guide-choice choice-combo">选择：打包产品</p>
                    <p class="guide-desc">适合希望同时训练CT操作流程和影像诊断能力的医生、医院和机构。</p>
                </div>
            </div>
        </section>

        <!-- 11 购买流程 -->
        <section class="section purchase-process">
            <div class="section-header centered white-text">
                <h2>购买后即可开始电脑端训练</h2>
            </div>
            <div class="process-steps">
                <div class="process-step">
                    <div class="step-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="shopping-cart" aria-hidden="true"
                            class="lucide lucide-shopping-cart">
                            <circle cx="8" cy="21" r="1"></circle>
                            <circle cx="19" cy="21" r="1"></circle>
                            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12">
                            </path>
                        </svg></div>
                    <h4>第一步：购买产品</h4>
                    <p>选择对应系统和使用时长，完成购买。</p>
                </div>
                <div class="process-step">
                    <div class="step-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="log-in" aria-hidden="true" class="lucide lucide-log-in">
                            <path d="m10 17 5-5-5-5"></path>
                            <path d="M15 12H3"></path>
                            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                        </svg></div>
                    <h4>第二步：进入系统</h4>
                    <p>在宠医客平台进入小动物CT影像实训系统。</p>
                </div>
                <div class="process-step">
                    <div class="step-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="mouse-pointer-click" aria-hidden="true"
                            class="lucide lucide-mouse-pointer-click">
                            <path d="M14 4.1 12 6"></path>
                            <path d="m5.1 8-2.9-.8"></path>
                            <path d="m6 12-1.9 2"></path>
                            <path d="M7.2 2.2 8 5.1"></path>
                            <path
                                d="M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z">
                            </path>
                        </svg></div>
                    <h4>第三步：选择内容</h4>
                    <p>选择进入操作实训或诊断思维训练系统。</p>
                </div>
                <div class="process-step">
                    <div class="step-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="play-circle" aria-hidden="true"
                            class="lucide lucide-play-circle">
                            <path
                                d="M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z">
                            </path>
                            <circle cx="12" cy="12" r="10"></circle>
                        </svg></div>
                    <h4>第四步：完成训练</h4>
                    <p>完成CT操作训练、病例阅片、报告书写。</p>
                </div>
                <div class="process-step">
                    <div class="step-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="line-chart" aria-hidden="true"
                            class="lucide lucide-line-chart">
                            <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                            <path d="m19 9-5 5-4-4-3 3"></path>
                        </svg></div>
                    <h4>第五步：查看反馈</h4>
                    <p>根据系统反馈、标准报告复盘问题持续提升。</p>
                </div>
            </div>
        </section>

        <!-- 12 FAQ -->
        <section id="faq" class="section faq-section">
            <h2 class="section-title centered">常见问题</h2>
            <div class="faq-grid">
                <div class="faq-item">
                    <h4><span class="faq-q">Q1:</span>这个产品需要安装软件吗？</h4>
                    <p>不需要。产品为电脑端在线使用，用户可通过宠医客平台进入对应系统。</p>
                </div>
                <div class="faq-item">
                    <h4><span class="faq-q">Q2:</span>没有真实CT设备基础，可以学习吗？</h4>
                    <p>可以。CT成像数字孪生系统实训会通过虚拟场景和流程引导，帮助用户了解小动物CT检查的基础流程。</p>
                </div>
                <div class="faq-item">
                    <h4><span class="faq-q">Q3:</span>两个系统有什么区别？</h4>
                    <p>数字孪生系统主要练操作（设备、麻醉、摆位、采集）；诊断思维系统主要练阅片（病例分析、报告书写、AI评阅）。</p>
                </div>
                <div class="faq-item">
                    <h4><span class="faq-q">Q4:</span>打包产品包含什么？</h4>
                    <p>同时包含 CT成像数字孪生系统实训 和 CT图像诊断思维训练系统，可同时进行操作训练与诊断训练。</p>
                </div>
                <div class="faq-item">
                    <h4><span class="faq-q">Q5:</span>3天体验包含哪个系统？</h4>
                    <p>3天体验仅包含 CT图像诊断思维训练系统（练诊断与报告）。</p>
                </div>
                <div class="faq-item">
                    <h4><span class="faq-q">Q6:</span>诊断训练系统中的病例是真实的吗？</h4>
                    <p>是。内置小动物真实CT/MR临床病例，支持病例调阅、阅片分析和报告书写。</p>
                </div>
                <div class="faq-item">
                    <h4><span class="faq-q">Q7:</span>AI评阅能替代老师吗？</h4>
                    <p>AI评阅帮助快速获得反馈，发现描述和逻辑问题。机构教学场景下，建议结合教师人工批改使用。</p>
                </div>
                <div class="faq-item">
                    <h4><span class="faq-q">Q8:</span>医院或院校可以统一购买吗？</h4>
                    <p>可以。医院、院校、培训机构如需批量采购或定制合作，可联系宠医客客服咨询。</p>
                </div>
            </div>
        </section>

        <!-- 13 Footer -->
        <footer class="footer">
            <div class="footer-content">
                <div class="footer-left">
                    <div class="footer-logo"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="cross" aria-hidden="true"
                            class="lucide lucide-cross text-brand-200 w-4 h-4">
                            <path
                                d="M4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a1 1 0 0 1 1 1v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a1 1 0 0 1-1-1V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a1 1 0 0 1-1 1z">
                            </path>
                        </svg></div>
                    <span>© 2026 宠医客 版权所有</span>
                </div>
                <div class="footer-links">
                    <a href="#">联系电话：021-64275859</a>
                </div>
            </div>
        </footer>

        <!-- 购买弹窗 Modal -->
        <div v-if="showPurchaseModal" class="modal-overlay" @click.self="closePurchaseModal">
            <div class="modal-content purchase-modal">
                <div class="modal-header">
                    <h3><svg xmlns="http://www.w3.org/2000/svg" color="#1066a9" width="20" height="20" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" data-lucide="shopping-cart" aria-hidden="true"
                            class="lucide lucide-shopping-cart w-5 h-5 text-brand-600">
                            <circle cx="8" cy="21" r="1"></circle>
                            <circle cx="19" cy="21" r="1"></circle>
                            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12">
                            </path>
                        </svg> 购买训练方案</h3>
                    <button class="modal-close" @click="closePurchaseModal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            data-lucide="x" aria-hidden="true" class="lucide lucide-x w-5 h-5">
                            <path d="M18 6 6 18"></path>
                            <path d="m6 6 12 12"></path>
                        </svg>
                    </button>
                </div>

                <div class="modal-tabs">
                    <button :class="['tab-btn', currentTab === 'sysA' ? 'active' : '']" @click="switchPurchaseTab('sysA')">
                        系统 A
                    </button>
                    <button :class="['tab-btn', currentTab === 'combo' ? 'active' : '']"
                        @click="switchPurchaseTab('combo')">
                        <span class="tab-badge">推荐</span>
                        A + B 打包
                    </button>
                    <button :class="['tab-btn', currentTab === 'sysB' ? 'active' : '']" @click="switchPurchaseTab('sysB')">
                        系统 B
                    </button>
                </div>

                <div class="modal-body">
                    <div v-show="currentTab === 'sysA'" class="purchase-page">
                        <div class="plan-card plan-sysA">
                            <div v-html="productListA[0].description"></div>
                            <p class="duration-label">选择使用时长</p>
                            <div class="duration-grid">
                                <button v-for="(item, index) in productListA" :key="index"
                                    :class="['duration-btn', selectedDuration.sysA?.duration == index ? 'selected' : '']"
                                    @click="selectDuration('sysA', index, item.selling_price, item.vip_duration)">
                                    <div class="duration-label-small">{{ item.vip_duration }}</div>
                                    <div class="duration-price">¥{{ item.selling_price }}</div>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-show="currentTab === 'combo'" class="purchase-page">
                        <div class="plan-card plan-combo">
                            <span class="plan-badge badge-combo">系统 A + B · 完整训练</span>
                            <h4>打包产品（系统 A + B）</h4>
                            <p class="plan-desc">同时包含CT操作实训与影像诊断思维训练，从扫描到出报告全流程覆盖，是最完整的小动物CT综合实训方案。</p>
                            <ul class="plan-features">
                                <li><svg xmlns="http://www.w3.org/2000/svg" color="#3286c0" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle-2"
                                        aria-hidden="true"
                                        class="lucide lucide-check-circle-2 w-4 h-4 text-brand-500 shrink-0">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>包含系统A全部功能</li>
                                <li><svg xmlns="http://www.w3.org/2000/svg" color="#3286c0" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle-2"
                                        aria-hidden="true"
                                        class="lucide lucide-check-circle-2 w-4 h-4 text-brand-500 shrink-0">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>包含系统B全部功能</li>
                                <li><svg xmlns="http://www.w3.org/2000/svg" color="#3286c0" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle-2"
                                        aria-hidden="true"
                                        class="lucide lucide-check-circle-2 w-4 h-4 text-brand-500 shrink-0">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>CT操作与诊断一体化</li>
                                <li><svg xmlns="http://www.w3.org/2000/svg" color="#3286c0" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle-2"
                                        aria-hidden="true"
                                        class="lucide lucide-check-circle-2 w-4 h-4 text-brand-500 shrink-0">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>病例库与报告书写训练</li>
                                <li><svg xmlns="http://www.w3.org/2000/svg" color="#3286c0" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle-2"
                                        aria-hidden="true"
                                        class="lucide lucide-check-circle-2 w-4 h-4 text-brand-500 shrink-0">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>双系统联动学习路径</li>
                            </ul>
                            <p class="duration-label">选择使用时长</p>
                            <div class="duration-grid">
                                <button v-for="(item, index) in productListAB" :key="index"
                                    :class="['duration-btn', selectedDuration.combo?.duration == index ? 'selected' : '']"
                                    @click="selectDuration('combo', index, item.selling_price, item.vip_duration)">
                                    <div class="duration-label-small">{{ item.vip_duration }}</div>
                                    <div class="duration-price">¥{{ item.selling_price }}</div>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-show="currentTab === 'sysB'" class="purchase-page">
                        <div class="plan-card plan-sysB">
                            <span class="plan-badge badge-sysB">练阅片诊断与报告</span>
                            <h4>CT图像诊断思维训练系统</h4>
                            <p class="plan-desc">基于真实CT/MR临床病例，训练病例调阅、影像分析、诊断报告书写与AI评阅反馈。</p>
                            <ul class="plan-features">
                                <li><svg xmlns="http://www.w3.org/2000/svg" color="#6366f1" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle-2"
                                        aria-hidden="true"
                                        class="lucide lucide-check-circle-2 w-4 h-4 text-brand-500 shrink-0">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>1000+ 真实CT/MR病例</li>
                                <li><svg xmlns="http://www.w3.org/2000/svg" color="#6366f1" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle-2"
                                        aria-hidden="true"
                                        class="lucide lucide-check-circle-2 w-4 h-4 text-brand-500 shrink-0">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>PACS病例调阅与专业测量工具</li>
                                <li><svg xmlns="http://www.w3.org/2000/svg" color="#6366f1" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle-2"
                                        aria-hidden="true"
                                        class="lucide lucide-check-circle-2 w-4 h-4 text-brand-500 shrink-0">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>MPR / MIP / 3D重建</li>
                                <li><svg xmlns="http://www.w3.org/2000/svg" color="#6366f1" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle-2"
                                        aria-hidden="true"
                                        class="lucide lucide-check-circle-2 w-4 h-4 text-brand-500 shrink-0">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>诊断报告书写训练</li>
                                <li><svg xmlns="http://www.w3.org/2000/svg" color="#6366f1" width="16" height="16"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" data-lucide="check-circle-2"
                                        aria-hidden="true"
                                        class="lucide lucide-check-circle-2 w-4 h-4 text-brand-500 shrink-0">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>AI评阅与标准报告对照</li>
                            </ul>
                            <p class="duration-label">选择使用时长</p>
                            <div class="duration-grid duration-grid-5">
                                <button v-for="(item, index) in productListB" :key="index"
                                    :class="['duration-btn', selectedDuration.sysB?.duration == index ? 'selected' : '']"
                                    @click="selectDuration('sysB', index, item.selling_price, item.vip_duration)">
                                    <div class="duration-label-small">{{ item.vip_duration }}</div>
                                    <div class="duration-price">¥{{ item.selling_price }}</div>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="page-nav">
                        <button class="nav-prev" :disabled="currentPageIndex === 0" @click="prevPage">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                data-lucide="chevron-left" aria-hidden="true" class="lucide lucide-chevron-left w-4 h-4">
                                <path d="m15 18-6-6 6-6"></path>
                            </svg><span>{{ prevLabel }}</span>
                        </button>
                        <span class="page-indicator">{{ currentPageIndex + 1 }} / 3</span>
                        <button class="nav-next" :disabled="currentPageIndex === 2" @click="nextPage">
                            <span>{{ nextLabel }}</span> <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" data-lucide="chevron-right"
                                aria-hidden="true" class="lucide lucide-chevron-right w-4 h-4">
                                <path d="m9 18 6-6-6-6"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="modal-footer">
                    <div class="summary">
                        <p class="summary-text">已选：<span class="summary-plan">{{ planName }}</span> · <span
                                class="summary-duration">{{ selectedDuration[currentTab]?.label || '' }}</span></p>
                        <p class="summary-price">¥<span>{{ selectedDuration[currentTab]?.price || '0' }}</span> <span
                                class="price-unit">/ <span>{{ selectedDuration[currentTab]?.label || '' }}</span></span></p>
                    </div>
                    <button class="btn-submit" @click="placeAnOrder">
                        立即下单付款
                    </button>
                </div>
                <!-- <p class="agreement-text">购买即代表同意 <a href="#">宠医客服务协议</a></p> -->
            </div>
        </div>

        <!-- 付款二维码弹窗 -->
        <div v-show="showPaymentModal" class="modal-overlay">
            <div class="modal-content payment-modal">
                <div class="modal-header">
                    <div>
                        <h3>扫码完成付款</h3>
                        <p class="order-info">订单：<span class="order-summary">{{ payOrderSummary }}</span></p>
                    </div>
                    <button class="modal-close" @click="closePaymentModal">
                        <i class="icon-x"></i>
                    </button>
                </div>

                <div class="payment-methods">
                    <button :class="['method-tab', payMethod === 'alipay' ? 'active' : '']"
                        @click="switchPayMethod('alipay')">
                        <svg viewBox="0 0 24 24" class="icon-alipay">
                            <path
                                d="M3 3h18v18H3V3zm9.3 11.1c-1.3-.4-3.1-1.3-4.3-2.2-.4-.3-.3-.8.1-1 .9-.5 2-.6 3.1-.3.7.2 1.3.5 1.8.9l.7-.9c-.6-.5-1.3-.9-2.1-1.1V8.5h-1.2v1.1c-1.5.3-2.6 1.3-2.6 2.6 0 1.5 1.4 2.5 3.2 3.1 1.2.4 2.1.9 2.1 1.6 0 .8-.9 1.3-2.1 1.3-1 0-2-.4-2.8-1l-.7.9c.9.7 2 1.1 3.2 1.2v1.2h1.2v-1.2c1.7-.2 2.9-1.2 2.9-2.7-.1-1.4-1.2-2.1-2.5-2.5z" />
                        </svg>
                        支付宝
                    </button>
                    <button :class="['method-tab', payMethod === 'wechat' ? 'active' : '']"
                        @click="switchPayMethod('wechat')">
                        <svg viewBox="0 0 24 24" class="icon-wechat">
                            <path
                                d="M8.7 11.2c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9zm4.6 0c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9zM12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm3.5-5.5c-.3.5-1 .8-1.8.8-.5 0-1-.1-1.4-.4l-.3.6c.5.3 1.1.5 1.7.5 1.1 0 2.1-.5 2.6-1.3l-.8-.2zm-7-.2c.5.8 1.5 1.3 2.6 1.3.6 0 1.2-.2 1.7-.5l-.3-.6c-.4.3-.9.4-1.4.4-.8 0-1.5-.3-1.8-.8l-.8.2z" />
                        </svg>
                        微信支付
                    </button>
                </div>

                <div class="payment-content" v-show="payMethod == 'alipay'">
                    <p class="payment-amount">¥{{ payPrice }}</p>
                    <p class="payment-timer"></p>
                    <!-- <p class="payment-timer">请在 <span class="timer-text">{{ payTimer }}</span> 内完成付款</p> -->
                    <div class="qr-code-placeholder">
                        <span>
                            <iframe :srcdoc="orderStr" frameborder="0" width="120px" style="padding-top: 30px;">
                            </iframe>
                        </span>
                    </div>
                    <p class="payment-tip">{{ payMethodTip }}</p>

                </div>

                <div class="payment-content" v-show="payMethod == 'wechat'">
                    <p class="payment-amount">¥{{ payPrice }}</p>
                    <p class="payment-timer"></p>
                    <div class="qr-code-placeholder">
                        <span><canvas ref="qrcodeCanvas"></canvas></span>
                    </div>
                    <p class="payment-tip">{{ payMethodTip }}</p>
                </div>

                <div class="payment-actions">
                    <button class="btn-confirm" @click="confirmPayment">
                        我已完成付款
                    </button>
                    <button class="btn-cancel" @click="closePaymentModal">
                        取消付款
                    </button>
                </div>
            </div>
        </div>


        <!-- 订单明细 -->
        <el-dialog :visible.sync="dialogVisible"  :close-on-click-modal="false"
            :destroy-on-close="true" title='订单记录'>
            <div class="orderTable">
                <el-table :data="UserOrderRecordData" border style="width: 100%;" height="400">
                    <el-table-column prop="order_no" label="订单号" width="180">
                    </el-table-column>
                    <el-table-column prop="order_time" label="下单时间" width="180">
                    </el-table-column>
                    <el-table-column prop="order_title" label="产品名称">
                    </el-table-column>
                    <el-table-column prop="pay_money" label="价格">
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>
  
<script>
import QRCode from 'qrcode'
export default {
    name: 'QrCodeComponent',
    name: 'PetCTTrainingLanding',
    data() {
        return {
            imgSrc: "https://case.chongyike.com",
            // 打开订单明细弹窗
            dialogVisible: false,
            isLoggedIn: false,
            userPhone: '',
            showPurchaseModal: false,
            showPaymentModal: false,
            // 选中的产品
            currentTab: 'combo',
            selectedDuration: {
                sysA: { price: '188', label: '1个月', duration: '0' },
                combo: { price: '288', label: '1个月', duration: '0' },
                sysB: { price: '9.9', label: '3天体验', duration: '0' }
            },
            payMethod: 'wechat',
            // 付款倒计时
            payTimer: '15:00',
            payTimerInterval: null,
            highlightTimerId: null,
            // 购买方案列表
            productListA: [],
            productListAB: [],
            productListB: [],
            // 回调地址
            notification_url: "",
            // 登录code
            accessCode: "",
            // 购买列表
            UserVip: [],
            // 支付宝支付二维码
            orderStr: "",
            // 订单列表
            UserOrderRecordData: [],
            // 当前订单号
            orderNo: "",
            // 下单按钮防抖
            placeAnOrderOff: false,
        }
    },
    computed: {
        maskedPhone() {
            var phone = this.userPhone
            if (!phone) return ''
            return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        },
        currentPageIndex() {
            const pages = ['sysA', 'combo', 'sysB']
            return pages.indexOf(this.currentTab)
        },
        prevLabel() {
            const labels = { sysA: '系统 A', combo: 'A + B 打包', sysB: '系统 B' }
            const pages = ['sysA', 'combo', 'sysB']
            const idx = this.currentPageIndex
            return idx > 0 ? labels[pages[idx - 1]] : ''
        },
        nextLabel() {
            const labels = { sysA: '系统 A', combo: 'A + B 打包', sysB: '系统 B' }
            const pages = ['sysA', 'combo', 'sysB']
            const idx = this.currentPageIndex
            return idx < 2 ? labels[pages[idx + 1]] : ''
        },
        planName() {
            const names = {
                sysA: 'CT成像数字孪生系统',
                combo: '打包产品（系统 A + B）',
                sysB: 'CT诊断思维训练系统'
            }
            return names[this.currentTab]
        },
        payOrderSummary() {
            const sel = this.selectedDuration[this.currentTab]
            return `${this.planName} · ${sel.label}`
        },
        payPrice() {
            return this.selectedDuration[this.currentTab]?.price || '0'
        },
        payMethodTip() {
            return this.payMethod === 'alipay' ? '请打开支付宝 App 扫码付款' : '请打开微信 App 扫码付款'
        }
    },
    created() {
        if (this.$route.query.notification_url) this.notification_url = this.$route.query.notification_url
    },
    mounted() {
        this.checkLoginState()
        this.initNavSlider()
        this.getUserVip()
        this.getVIPList(1)
        this.getVIPList(2)
        this.getVIPList(3)
        this.getCode()
    },
    beforeDestroy() {
        if (this.payTimerInterval) {
            clearInterval(this.payTimerInterval)
        }
        if (this.highlightTimerId) {
            clearTimeout(this.highlightTimerId)
        }
    },
    methods: {
        // 跳转页面
        jumpRouter(item){
            const that = this
            if(item.url){
                window.open(item.url)
            }else if(that.$route.path != item.router){
                // 同地址不能跳转
                // 没有子路由的可以直接跳转
                if(!item.children){
                    that.$router.push({
                        path: item.router,
                    })
                }
            }
        },
        // 获取code
        getCode(type) {
            const that = this
            var data = {
                type: 'getCode',
            }
            this.get('/peiyun/handler', data).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    this.accessCode = result.code
                    if (this.notification_url) {
                        console.log(this.notification_url)
                        window.open(this.notification_url + "?code=" + result.code)
                    }else {
                        if(type == 1){
                            window.open("https://peiyun.cn/V-LAB/enter/cyk/index.html?code=" + result.code + "&exp=uAniCT")
                        }else if(type == 2){
                            window.open("https://peiyun.cn/V-LAB/enter/cyk/index.html?code=" + result.code + "&exp=PACSEXT")
                        }
                    }
                }
            })
        },
        // 判断是否拥有权限
        getUserVip() {
            const that = this
            var data = {
                type: 'getUserVip',
            }
            this.get("/peiyun/handler", data).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    // 判断权限是否过期
                    for (let i = 0; i < result.length; i++) {
                        const element = result[i];
                        if(this.customDateStringToTimestamp(this.getCurrentDate(2)) < this.customDateStringToTimestamp(element.vip_end_time)){
                            element.usable = true
                        }
                    }
                    that.UserVip = result
                }
            })
        },
        // 获取订单记录
        getUserOrderRecord() {
            const that = this
            var data = {
                type: 'getUserOrderRecord',
            }
            this.get("/peiyun/handler", data).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    this.UserOrderRecordData = result
                }
            })
        },
        // 获取商品信息
        getVIPList(vipType) {
            const that = this
            var data = {
                type: 'getVIPList',
                vipType: vipType,
            }
            this.get("/peiyun/handler", data).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    if (vipType == 1) {
                        that.productListA = result
                        var element = result[0]
                        that.selectedDuration.sysA = {
                            price: element.selling_price,
                            label: element.vip_duration,
                            duration: '0'
                        }
                    } else if (vipType == 3) {
                        that.productListAB = result
                        var element = result[0]
                        that.selectedDuration.combo = {
                            price: element.selling_price,
                            label: element.vip_duration,
                            duration: '0'
                        }
                    } else if (vipType == 2) {
                        that.productListB = result
                        var element = result[0]
                        that.selectedDuration.sysB = {
                            price: element.selling_price,
                            label: element.vip_duration,
                            duration: '0'
                        }
                    }
                }
            })
        },
        // 下单
        placeAnOrder() {
            const that = this
            if(this.placeAnOrderOff){
                return  false
            }
            this.placeAnOrderOff = true
            var activeItem
            if (this.currentTab == 'sysA') {
                activeItem = that.productListA[this.selectedDuration[this.currentTab].duration]
            } else if (this.currentTab == 'combo') {
                activeItem = that.productListAB[this.selectedDuration[this.currentTab].duration]
            } else if (this.currentTab == 'sysB') {
                activeItem = that.productListB[this.selectedDuration[this.currentTab].duration]
            }
            var rndnum = that.RndNum(4);
            var now = that.gettime();
            var order_no = now + rndnum + JSON.parse(that.Cookies.get("loginInfo")).No;
            var text = {
                order_no: order_no,
                order_money: activeItem.selling_price,
                pay_money: activeItem.selling_price,
                order_items: [
                    {
                        data_no: activeItem.v_id,
                        num: 1
                    }
                ]
            }
            var key = that.Cookies.get('token')
            var data = {
                type: 'placeAnOrder',
                text: that.encrypt(JSON.stringify(text), key.slice(0, 16)),
            }
            this.get("/peiyun/handler", data, 1).then((res) => {
                this.placeAnOrderOff = false
                if (res.data.code == "success") {
                    var result = res.data.result
                    var datas = JSON.parse(that.decrypt(result, key.slice(0, 16)))
                    this.orderNo = datas.order_no
                    this.showPaymentModal = true
                    that.getPayInfo('2')
                    // that.orderNo = datas.order_no
                    // that.payPrice = datas.vip_money
                }
            })
        },
        // 获取支付信息
        getPayInfo(payType) {
            const that = this
            var data = {
                type: 'getPayInfo',
                orderNo: this.orderNo,
                payType: payType,
                orderType: "18",
                phtype: "WEB"
            }
            this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    var orderStr = result.orderStr
                    if (payType == '2') {
                        var codeUrl = JSON.parse(that.decrypt(orderStr, "recruitorder_app")).codeUrl
                        this.startPayTimer(15 * 60)
                        that.generateQRCode(codeUrl)
                    } else if (payType == '1') {
                        // that.generateQRCode(orderStr)
                        if (!orderStr.includes('document.forms[0].submit()')) {
                            // 如果没有，手动注入
                            orderStr = orderStr.replace('</body>', `
                                <script>
                                // 等待页面加载完成后再提交
                                window.onload = function() {
                                    document.forms[0].submit();
                                };
                                <\/script>
                            </body>`);
                        }
                        that.orderStr = orderStr
                    }
                }
            })
        },
        // 生成二维码
        generateQRCode(str) {
            QRCode.toCanvas(this.$refs.qrcodeCanvas, str, function (error) {
                if (error) console.error(error)
                console.log('success!')
            })
        },
        // 获取时间
        gettime() {
            var nowYear = new Date().getFullYear().toString()
            var nowMonth = (new Date().getMonth() + 1).toString()
            var nowDay = new Date().getDate().toString();
            var nowHours = new Date().getHours().toString(); //获取当前小时数(0-23)
            var nowMin = new Date().getMinutes().toString(); //获取当前分钟数(0-59)
            var nowSeconds = new Date().getSeconds().toString(); //获取当前秒数(0-59)
            function timeAdd0(str) {
                if (str.length <= 1) {
                    str = '0' + str;
                }
                return str
            }
            nowYear = timeAdd0(nowYear)
            nowMonth = timeAdd0(nowMonth)
            nowDay = timeAdd0(nowDay)
            nowHours = timeAdd0(nowHours)
            nowMin = timeAdd0(nowMin)
            nowSeconds = timeAdd0(nowSeconds)
            return nowYear + nowMonth + nowDay + nowHours + nowMin + nowSeconds;
        },
        // 生成随机函数
        RndNum(n) {
            var res = ''
            for (; res.length < n; res += Math.random().toString(36).substr(2).toUpperCase()) { }
            return res.substr(0, n)
        },
        // ================================================================================================
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },
        scrollToSection(id) {
            const element = document.getElementById(id)
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' })
            }
        },
        // 打开产品弹窗
        openPurchaseModal(preselectPlan = null) {
            if (!this.isLoggedIn) {
                this.$emit("loginBoxShow", 1)
                return
            }
            this.showPurchaseModal = true

            const target = preselectPlan || 'combo'
            this.switchPurchaseTab(target)
        },
        // 关闭购买弹窗
        closePurchaseModal() {
            this.showPurchaseModal = false
            document.body.style.overflow = ''
        },
        // 切换选中产品
        switchPurchaseTab(tab) {
            this.currentTab = tab
        },
        // 切换产品时长
        selectDuration(plan, duration, price, label) {
            this.selectedDuration[plan] = { price, label, duration }
        },
        // 购买框左箭头按钮
        prevPage() {
            const pages = ['sysA', 'combo', 'sysB']
            const idx = this.currentPageIndex
            if (idx > 0) {
                this.currentTab = pages[idx - 1]
            }
        },
        // 购买框右箭头按钮
        nextPage() {
            const pages = ['sysA', 'combo', 'sysB']
            const idx = this.currentPageIndex
            if (idx < 2) {
                this.currentTab = pages[idx + 1]
            }
        },
        // 点击取消付款
        closePaymentModal() {
            this.showPaymentModal = false
            if (this.payTimerInterval) {
                clearInterval(this.payTimerInterval)
                this.payTimerInterval = null
            }
        },
        // alipay支付宝还是wechat微信支付
        switchPayMethod(method) {
            this.payMethod = method
            if(method == 'wechat'){
                this.getPayInfo('2')
            }else {
                this.getPayInfo('1')
            }
        },
        // 订单倒计时
        startPayTimer(seconds) {
            if (this.payTimerInterval) clearInterval(this.payTimerInterval)
            let remaining = seconds
            const fmt = s => String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0')
            this.payTimer = fmt(remaining)
            this.payTimerInterval = setInterval(() => {
                remaining--
                this.payTimer = fmt(remaining)
                if (remaining <= 0) {
                    clearInterval(this.payTimerInterval)
                    this.payTimerInterval = null
                    this.closePaymentModal()
                    this.$message({
                        showClose: true,
                        message: "付款超时，订单已取消，请重新下单。",
                    });
                }
            }, 1000)
        },
        // 点击付款成功
        confirmPayment() {
			const that = this
            var data = {
                type: "selectOrderPaySatu",
				orderNo: that.orderNo,
				orderType: '18',
            }
            that.get("/webhttp/mobileHandler",data, 1).then((res)=>{
                if(res.data.code == "success"){
                    var result = res.data.result
                    if(result.pay_statu == 1){
                        this.closePaymentModal()
                        this.closePurchaseModal()
                        this.getUserOrderRecord()
                        window.location.reload()
                        this.$message({
                            showClose: true,
                            message: "支付成功",
                            type: 'success'
                        });
                    }else {
                        this.$message({
                            showClose: true,
                            message: "未查到支付信息",
                            type: 'warning'
                        });
                    }
                }
            })
            // this.$message({
            //     showClose: true,
            //     message: "感谢您的购买！系统将为您开通权限。",
            //     type: "success"
            // });
        },
        // 查看价格方案以及进入系统
        handleSecondaryBtnClick(e) {
            e.preventDefault()
            document.body.style.overflow = ''
            this.scrollToSection('pricing')
        },
        // 进入系统
        jumpSystem(item) {
            if(item.usable){
                this.getCode(item.vip_type)
            }else {
                this.$message({
                    showClose: true,
                    message: "权限已过期，请重新购买",
                })
            }
        },
        // 判断跳转对应位置
        highlightPricing(cardId) {
            this.scrollToSection('pricing')

            if (this.highlightTimerId) clearTimeout(this.highlightTimerId)

            this.highlightTimerId = setTimeout(() => {
                const cards = {
                    'pricing-sysA': this.$refs.pricingSysA,
                    'pricing-sysB': this.$refs.pricingSysB,
                    'pricing-combo': this.$refs.pricingCombo
                }

                Object.values(cards).forEach(card => {
                    if (card) {
                        card.classList.remove('highlight-pulse', 'pricing-selected-sysB', 'pricing-selected-combo')
                    }
                })

                const card = cards[cardId]
                if (card) {
                    if (cardId === 'pricing-sysB') {
                        card.classList.add('highlight-pulse', 'pricing-selected-sysB')
                    } else if (cardId === 'pricing-combo') {
                        card.classList.add('highlight-pulse', 'pricing-selected-combo')
                    } else if (cardId === 'pricing-sysA') {
                        card.classList.add('highlight-pulse')
                    }

                    setTimeout(() => {
                        card.classList.remove('highlight-pulse')
                    }, 2500)
                }
            }, 500)
        },
        initNavSlider() {
            const nav = this.$refs.topNav
            const slider = this.$refs.navSlider
            if (!nav || !slider) return

            const links = nav.querySelectorAll('.nav-item')
            links.forEach(link => {
                link.addEventListener('mouseenter', (e) => {
                    const rect = e.target.getBoundingClientRect()
                    const navRect = nav.getBoundingClientRect()

                    slider.style.width = `${rect.width}px`
                    slider.style.transform = `translateX(${rect.left - navRect.left}px)`
                    slider.style.opacity = '1'
                })
            })

            nav.addEventListener('mouseleave', () => {
                slider.style.opacity = '0'
            })
        },
        // 判断是否登录
        checkLoginState() {
            const isLoggedIn = this.Cookies.get('loginInfo') ? true : false
            const phone = isLoggedIn ? JSON.parse(this.Cookies.get('loginInfo')).phone : false
            if (isLoggedIn && phone) {
                this.isLoggedIn = true
                this.userPhone = phone
                document.body.style.overflow = ''
                this.getUserOrderRecord()
            } else {
                this.isLoggedIn = false
                this.userPhone = ''
                // this.$emit("loginBoxShow", 1)
            }
        },
        // 退出登录
        handleLogout() {
            this.$emit("loginOut")
            setTimeout(() => {
                window.location.reload()
            }, 500);
        },
        loginBox() {
            this.$emit("loginBoxShow", 1)
        },
    }
}
</script>
<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
}

body {
    background-color: #f1f5f9;
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    color: #334155;
}

.app-container {
    width: 1440px;
    min-width: 1440px;
    background-color: #ffffff;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.1);
    position: relative;
    margin: 0 auto;
}

.glass-header {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(226, 232, 240, 0.8);
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 1440px;
    z-index: 50;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
}

.logo-section {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: opacity 0.3s;

    &:hover {
        opacity: 0.9;
    }

    .logo-img {
        height: 40px;
        width: auto;
        object-fit: contain;
    }

    .system-name {
        margin-left: 16px;
        padding-left: 16px;
        border-left: 2px solid #e2e8f0;
        font-size: 14px;
        font-weight: 600;
        color: #64748b;
    }
}

.nav-menu {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #475569;

    .nav-slider {
        position: absolute;
        left: 0;
        height: 36px;
        background: #f0f6fa;
        border-radius: 9999px;
        transition: all 0.3s ease-out;
        opacity: 0;
        pointer-events: none;
        z-index: 0;
    }

    .nav-item {
        position: relative;
        z-index: 10;
        padding: 8px 16px;
        transition: color 0.3s;
        border-radius: 9999px;
        text-decoration: none;

        &:hover {
            color: #1066A9;
        }
    }
}

.login-btn {
    background: #1066A9;
    color: white;
    padding: 10px 24px;
    border-radius: 9999px;
    font-weight: 500;
    transition: all 0.3s;
    box-shadow: 0 10px 15px -3px rgba(16, 102, 169, 0.3);
    border: none;
    cursor: pointer;

    &:hover {
        background: #115289;
        box-shadow: 0 10px 15px -3px rgba(16, 102, 169, 0.5);
        transform: translateY(-2px);
    }
}

.user-info {
    display: flex;
    align-items: center;
    gap: 12px;

    .orderBtn {
        cursor: pointer;

        &:hover {
            color: #fff;
            background-color: #1066A9;
        }
    }

    .phone-display {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 16px;
        background: #f1f5f9;
        border: 1px solid #e2e8f0;
        border-radius: 9999px;
        font-size: 14px;
        font-weight: 600;
        color: #334155;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

        .user-icon {
            background: #dbeafe;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            border-radius: 50%;

            .icon-user {
                width: 14px;
                height: 14px;
                color: #1066A9;
            }
        }
    }

    .logout-btn {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 16px;
        border-radius: 9999px;
        font-size: 14px;
        font-weight: 500;
        color: #64748b;
        border: 1px solid #e2e8f0;
        background: transparent;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
            background: #fef2f2;
            color: #ef4444;
            border-color: #fecaca;
        }

        .icon-logout {
            width: 14px;
            height: 14px;
        }
    }
}

.hero-section {
    display: flex;
    height: 720px;
    position: relative;
    overflow: hidden;
    background: #f8fafc;

    .bg-blur {
        position: absolute;
        border-radius: 9999px;
        filter: blur(80px);
        opacity: 0.5;
        pointer-events: none;
    }

    .brand-blur {
        top: 0;
        right: 0;
        width: 800px;
        height: 800px;
        background: #f0f6fa;
        transform: translate(-50%, -50%) translateX(25%);
    }

    .sysA-blur {
        bottom: 0;
        left: 0;
        width: 600px;
        height: 600px;
        background: #f0fdfa;
        transform: translateY(33.33%) translateX(-25%);
    }

    .hero-content {
        width: 55%;
        padding: 0 80px 0 80px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        z-index: 10;
        position: relative;

        .feature-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
            margin-bottom: 32px;

            .tag {
                padding: 4px 12px;
                background: white;
                border: 1px solid #e2e8f0;
                border-radius: 9999px;
                font-size: 12px;
                font-weight: 600;
                color: #475569;
                display: flex;
                align-items: center;
                gap: 4px;
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

                i {
                    width: 12px;
                    height: 12px;
                }
            }
        }

        .hero-title {
            font-size: 52px;
            line-height: 1.1;
            font-weight: 800;
            color: #0f172a;
            letter-spacing: -0.025em;
            margin-bottom: 16px;
        }

        .hero-subtitle {
            font-size: 24px;
            font-weight: 500;
            color: #475569;
            margin-bottom: 24px;
            background: linear-gradient(135deg, #1066A9 0%, #569fd2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .hero-description {
            font-size: 18px;
            color: #64748b;
            line-height: 1.75;
            margin-bottom: 40px;
            max-width: 640px;
        }

        .hero-buttons {
            display: flex;
            align-items: center;
            gap: 16px;

            .btn-primary {
                background: #1066A9;
                color: white;
                padding: 16px 32px;
                border-radius: 12px;
                font-weight: 700;
                font-size: 18px;
                transition: all 0.3s;
                box-shadow: 0 20px 25px -5px rgba(16, 102, 169, 0.3);
                border: none;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 8px;

                &:hover {
                    background: #115289;
                    box-shadow: 0 20px 25px -5px rgba(16, 102, 169, 0.5);
                    transform: translateY(-4px);
                }

                i {
                    width: 20px;
                    height: 20px;
                }
            }

            .btn-secondary {
                background: white;
                color: #334155;
                padding: 16px 32px;
                border-radius: 12px;
                font-weight: 700;
                font-size: 18px;
                transition: all 0.3s;
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
                border: 1px solid #e2e8f0;
                cursor: pointer;
                display: flex;
                align-items: center;
                flex-direction: column;
                gap: 8px;
                text-decoration: none;

                &:hover {
                    background: #f8fafc;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                }
                .systemBtn {
                    font-size: 13px;
                    color: #6366f1;
                }
                .systemBtn2 {
                    color: #14b8a6;
                }
            }
        }
    }

    .hero-images {
        width: 45%;
        position: relative;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 40px;

        .image-stack {
            position: relative;
            width: 650px;
            height: 550px;
            perspective: 1000px;

            .image-card {
                position: absolute;
                border-radius: 16px;
                overflow: hidden;
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
                border: 4px solid white;
                transition: transform 0.5s;

                // &:hover {
                //     transform: scale(1.05);
                // }

                .image-placeholder {
                    width: 100%;
                    height: 100%;
                    background: #e2e8f0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: #94a3b8;

                    .petCtTrainingLandingImg {
                        width: 100%;
                    }
                    i {
                        width: 48px;
                        height: 48px;
                        margin-bottom: 8px;
                    }

                    span {
                        font-size: 14px;
                        font-weight: 500;
                    }
                }

                .card-label {
                    position: absolute;
                    bottom: 12px;
                    left: 12px;
                    background: rgba(255, 255, 255, 0.9);
                    backdrop-filter: blur(4px);
                    padding: 4px 12px;
                    border-radius: 6px;
                    font-size: 12px;
                    font-weight: 700;
                    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
                }

                .label-sysB {
                    color: #4f46e5;
                }

                .label-default {
                    color: #334155;
                }

                .label-sysA {
                    color: #0d9488;
                }
            }

            .card-3 {
                right: 0;
                bottom: 40px;
                width: 450px;
                height: 300px;
                transform: rotate(3deg) translateX(16px) translateY(32px);
                z-index: 10;

                &::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background: rgba(99, 102, 241, 0.1);
                    mix-blend-mode: multiply;
                    pointer-events: none;
                }
            }

            .card-2 {
                left: 40px;
                top: 50%;
                width: 480px;
                height: 320px;
                transform: rotate(-2deg) translateY(-50%) translateX(-32px);
                z-index: 20;
            }

            .card-1 {
                right: 48px;
                top: 0;
                width: 500px;
                height: 350px;
                transform: translateY(16px) translateX(-16px);
                z-index: 30;

                &::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background: rgba(13, 148, 136, 0.1);
                    mix-blend-mode: overlay;
                    pointer-events: none;
                }
            }
        }
    }
}

.section {
    padding: 96px 80px;

    .section-header {
        text-align: center;
        max-width: 768px;
        margin: 0 auto 64px;

        h2 {
            font-size: 30px;
            font-weight: 700;
            color: #0f172a;
            margin-bottom: 16px;
        }

        p {
            font-size: 18px;
            color: #64748b;
        }

        &.centered {
            text-align: center;
        }

        &.left-aligned {
            text-align: left;
            max-width: none;
            margin-left: 0;
        }

        &.right-aligned {
            text-align: right;
            max-width: none;
            margin-right: 0;
            margin-left: auto;
        }

        &.white-text {
            h2 {
                color: white;
            }
        }
    }
}

.overview-section {
    background: white;

    .systems-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 40px;

        .system-card {
            background: white;
            border-radius: 32px;
            padding: 40px;
            border: 1px solid #e2e8f0;
            box-shadow: 0 20px 25px -5px rgba(226, 232, 240, 0.5);
            transition: all 0.3s;
            position: relative;
            overflow: hidden;

            &:hover {
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
                transform: translateY(-4px);
            }

            .card-accent {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 6px;
            }

            .accent-a {
                background: #14b8a6;
            }

            .accent-b {
                background: #6366f1;
            }

            .card-glow {
                position: absolute;
                right: -80px;
                top: -80px;
                width: 256px;
                height: 256px;
                border-radius: 9999px;
                filter: blur(80px);
                opacity: 0;
                transition: opacity 0.5s;
            }

            .glow-a {
                background: #f0fdfa;
            }

            .glow-b {
                background: #eef2ff;
            }

            &:hover .card-glow {
                opacity: 1;
            }

            .system-badge {
                display: inline-block;
                padding: 4px 12px;
                font-size: 12px;
                font-weight: 700;
                border-radius: 9999px;
                margin-bottom: 16px;
            }

            .badge-a {
                background: #f0fdfa;
                color: #0d9488;
                border: 1px solid #99f6e4;
            }

            .badge-b {
                background: #eef2ff;
                color: #4f46e5;
                border: 1px solid #c7d2fe;
            }

            .system-title {
                font-size: 24px;
                font-weight: 700;
                color: #0f172a;
                margin-bottom: 12px;
                transition: color 0.3s;
            }

            &:hover .system-title {
                &.system-a & {
                    color: #0d9488;
                }

                &.system-b & {
                    color: #4f46e5;
                }
            }

            .system-description {
                color: #64748b;
                margin-bottom: 32px;
                min-height: 72px;
            }

            .training-content {
                margin-bottom: 32px;

                .content-title {
                    font-size: 14px;
                    font-weight: 600;
                    color: #0f172a;
                    margin-bottom: 12px;
                    display: flex;
                    align-items: center;
                    gap: 8px;

                    i {
                        width: 16px;
                        height: 16px;
                    }
                }

                .content-list {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 8px;
                    list-style: none;
                    font-size: 14px;
                    color: #475569;

                    li {
                        display: flex;
                        align-items: center;
                        gap: 8px;

                        &.full-width {
                            grid-column: 1 / -1;
                        }

                        .dot {
                            width: 6px;
                            height: 6px;
                            border-radius: 9999px;
                            flex-shrink: 0;
                        }

                        .dot-a {
                            background: #5eead4;
                        }

                        .dot-b {
                            background: #818cf8;
                        }
                    }
                }
            }

            .suitable-box {
                margin-bottom: 32px;
                padding: 16px;
                background: #f8fafc;
                border-radius: 12px;

                h4 {
                    font-size: 14px;
                    font-weight: 600;
                    color: #0f172a;
                    margin-bottom: 8px;
                }

                p {
                    font-size: 14px;
                    color: #475569;
                    line-height: 1.625;
                }
            }

            .btn-outline {
                width: 100%;
                padding: 16px;
                border-radius: 12px;
                font-weight: 700;
                transition: all 0.3s;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 8px;
                cursor: pointer;
                background: transparent;

                i {
                    width: 16px;
                    height: 16px;
                }
            }

            .btn-outline-a {
                border: 2px solid #14b8a6;
                color: #0d9488;

                &:hover {
                    background: #14b8a6;
                    color: white;
                }
            }

            .btn-outline-b {
                border: 2px solid #6366f1;
                color: #4f46e5;

                &:hover {
                    background: #6366f1;
                    color: white;
                }
            }
        }
    }
}

.pain-points-section {
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;

    .pain-points-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 24px;

        .pain-point-card {
            background: white;
            padding: 32px;
            border-radius: 16px;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
            border: 1px solid #f1f5f9;
            transition: box-shadow 0.3s;

            &:hover {
                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
            }

            .icon-box {
                width: 48px;
                height: 48px;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 24px;

                i {
                    width: 24px;
                    height: 24px;
                }
            }

            .icon-red {
                background: #fef2f2;

                i {
                    color: #ef4444;
                }
            }

            .icon-orange {
                background: #fff7ed;

                i {
                    color: #f97316;
                }
            }

            .icon-brand {
                background: #f0f6fa;

                i {
                    color: #1066A9;
                }
            }

            .icon-purple {
                background: #faf5ff;

                i {
                    color: #a855f7;
                }
            }

            h3 {
                font-size: 18px;
                font-weight: 700;
                color: #0f172a;
                margin-bottom: 12px;
            }

            p {
                font-size: 14px;
                color: #64748b;
                line-height: 1.625;
            }
        }
    }
}

.feature-sysA-section {
    background: white;
    position: relative;
    overflow: hidden;

    .section-bg {
        position: absolute;
        right: 0;
        top: 0;
        width: 50%;
        height: 100%;
        pointer-events: none;
    }

    .skew-bg-a {
        background: rgba(20, 184, 166, 0.05);
        transform: skewX(-12deg) translateX(128px);
    }

    .section-label {
        display: block;
        font-weight: 700;
        letter-spacing: 0.1em;
        font-size: 14px;
        margin-bottom: 8px;
        text-transform: uppercase;
    }

    .label-sysA {
        color: #0d9488;
    }

    .feature-content {
        display: flex;
        gap: 64px;
        position: relative;
        z-index: 10;

        .workflow-panel {
            width: 40%;
            background: #f0fdfa;
            padding: 32px;
            border-radius: 32px;
            border: 1px solid #ccfbf1;
            height: 100%;

            .workflow-title {
                font-size: 18px;
                font-weight: 700;
                color: #14b8a6;
                margin-bottom: 32px;
                display: flex;
                align-items: center;
                gap: 8px;

                i {
                    width: 20px;
                    height: 20px;
                    color: #14b8a6;
                }
            }

            .workflow-steps {
                position: relative;
                border-left: 2px solid #99f6e4;
                margin-left: 16px;
                padding-bottom: 16px;

                .step {
                    position: relative;
                    padding-left: 24px;
                    margin-bottom: 24px;

                    .step-dot {
                        position: absolute;
                        width: 16px;
                        height: 16px;
                        background: white;
                        border: 2px solid #14b8a6;
                        border-radius: 9999px;
                        left: -9px;
                        top: 4px;

                        &.highlighted {
                            background: #14b8a6;
                            box-shadow: 0 0 0 4px rgba(20, 184, 166, 0.2);
                        }
                    }

                    h4 {
                        font-weight: 600;
                        color: #0f172a;
                    }

                    .step-note {
                        font-size: 12px;
                        color: #0d9488;
                        margin-top: 4px;
                    }

                    &.step-highlight {
                        h4 {
                            font-weight: 700;
                            color: #115e59;
                        }
                    }
                }
            }
        }

        .features-grid {
            width: 60%;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 32px;

            .feature-item {
                .feature-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 12px;

                    i {
                        width: 20px;
                        height: 20px;
                    }
                }

                .icon-sysA {
                    background: #ccfbf1;
                    color: #0d9488;
                }

                h4 {
                    font-weight: 700;
                    color: #0f172a;
                    font-size: 18px;
                    margin-bottom: 12px;
                }

                p {
                    font-size: 14px;
                    color: #64748b;
                    line-height: 1.625;
                }

                &.full-width {
                    grid-column: 1 / -1;
                }

                &.bg-light {
                    background: #f8fafc;
                    padding: 24px;
                    border-radius: 12px;
                    border: 1px solid #f1f5f9;

                    h4 {
                        display: flex;
                        align-items: center;
                        gap: 8px;

                        i {
                            width: 20px;
                            height: 20px;
                            color: #14b8a6;
                        }
                    }
                }
            }
        }
    }
}

.feature-sysB-section {
    background: #f8fafc;
    position: relative;
    overflow: hidden;

    .section-bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 50%;
        height: 100%;
        pointer-events: none;
    }

    .skew-bg-b {
        background: white;
        transform: skewX(12deg) translateX(-128px);
    }

    .section-label {
        display: block;
        font-weight: 700;
        letter-spacing: 0.1em;
        font-size: 14px;
        margin-bottom: 8px;
        text-transform: uppercase;
    }

    .label-sysB {
        color: #4f46e5;
    }

    .feature-content {
        display: flex;
        gap: 64px;
        position: relative;
        z-index: 10;
        flex-direction: row-reverse;

        .right-panel {
            width: 40%;
            display: flex;
            flex-direction: column;
            gap: 24px;

            .cycle-flow {
                background: white;
                padding: 24px;
                border-radius: 32px;
                border: 1px solid #e2e8f0;
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-left: 32px;
                padding-right: 32px;
                font-size: 14px;
                font-weight: 600;
                color: #334155;

                .flow-step {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 8px;
                    font-size: 12px;

                    .step-number {
                        width: 32px;
                        height: 32px;
                        border-radius: 9999px;
                        background: #eef2ff;
                        color: #4f46e5;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &.highlighted {
                            background: #6366f1;
                            color: white;
                            box-shadow: 0 10px 15px -3px rgba(99, 102, 241, 0.4);
                        }
                    }

                    &.highlight {
                        .step-number {
                            background: #6366f1;
                            color: white;
                            box-shadow: 0 10px 15px -3px rgba(99, 102, 241, 0.4);
                        }
                    }
                }

                .flow-arrow {
                    width: 16px;
                    height: 16px;
                    color: #cbd5e1;
                }
            }

            .image-mockup {
                background: #114674;
                border-radius: 32px;
                padding: 8px;
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
                position: relative;
                height: 100%;
                min-height: 400px;
                overflow: hidden;
                border: 1px solid #1e3a5f;

                .mockup-content {
                    width: 100%;
                    height: 100%;
                    background: #1e3a5f;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: #93c5fd;
                    border-radius: 24px;
                    transition: transform 0.7s;

                    &:hover {
                        transform: scale(1.05);
                    }

                    i {
                        width: 64px;
                        height: 64px;
                        margin-bottom: 16px;
                    }

                    span {
                        font-size: 18px;
                        font-weight: 500;
                    }
                }

                .mockup-overlay {
                    position: absolute;
                    inset: 0;
                    background: linear-gradient(to top, rgba(15, 23, 42, 0.9), transparent);
                    display: flex;
                    align-items: flex-end;
                    padding: 32px;
                    pointer-events: none;

                    .overlay-badge {
                        display: inline-block;
                        padding: 4px 12px;
                        background: rgba(99, 102, 241, 0.2);
                        color: #c7d2fe;
                        font-size: 12px;
                        font-weight: 700;
                        border-radius: 4px;
                        border: 1px solid rgba(99, 102, 241, 0.3);
                        backdrop-filter: blur(4px);
                        margin-bottom: 8px;
                    }

                    p {
                        color: white;
                        font-weight: 500;
                    }
                }
            }
        }

        .features-grid {
            width: 60%;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 32px;

            .feature-item {
                .feature-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 12px;
                    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
                    border: 1px solid #f1f5f9;

                    i {
                        width: 20px;
                        height: 20px;
                    }
                }

                .icon-white {
                    background: white;
                    color: #4f46e5;
                }

                h4 {
                    font-weight: 700;
                    color: #0f172a;
                    font-size: 18px;
                    margin-bottom: 12px;
                }

                p {
                    font-size: 14px;
                    color: #64748b;
                    line-height: 1.625;
                }

                &.bg-sysB-light {
                    background: #eef2ff;
                    padding: 24px;
                    border-radius: 12px;
                    border: 1px solid #e0e7ff;

                    h4 {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 18px;

                        i {
                            width: 20px;
                            height: 20px;
                            color: #4f46e5;
                        }
                    }
                }

                &.bg-white-border {
                    background: white;
                    padding: 24px;
                    border-radius: 12px;
                    border: 1px solid #e2e8f0;
                    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

                    h4 {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 18px;

                        i {
                            width: 20px;
                            height: 20px;
                            color: #10b981;
                        }
                    }
                }
            }
        }
    }
}

.audience-section {
    background: white;

    .audience-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
        max-width: 768px;
        margin: 0 auto;

        .audience-card {
            background: #f8fafc;
            border-radius: 16px;
            padding: 24px;
            border: 1px solid #f1f5f9;
            display: flex;
            flex-direction: column;

            .card-header {
                margin-bottom: 16px;

                h3 {
                    font-size: 18px;
                    font-weight: 700;
                    color: #0f172a;
                    margin-bottom: 4px;
                }

                p {
                    font-size: 12px;
                    color: #64748b;
                }
            }

            .benefit-list {
                list-style: none;
                font-size: 14px;
                color: #475569;
                margin-bottom: 32px;
                flex: 1;

                li {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
            }

            .btn-recommend {
                font-size: 14px;
                font-weight: 600;
                color: #1066A9;
                background: #f0f6fa;
                padding: 12px;
                border-radius: 12px;
                transition: all 0.3s;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 4px;
                cursor: pointer;
                border: none;

                &:hover {
                    background: #dbeafe;
                    color: #115289;
                }

                i {
                    width: 16px;
                    height: 16px;
                }
            }
        }
    }
}

.advantages-section {
    background: #115289;
    color: white;
    position: relative;

    .advantages-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 32px;
        position: relative;
        z-index: 10;

        .advantage-card {
            padding: 24px;
            border: 1px solid #3b82f6;
            border-radius: 16px;
            background: #105a96;
            backdrop-filter: blur(4px);

            h3 {
                margin-top: 16px;
                font-size: 18px;
                font-weight: 700;
                margin-bottom: 8px;
            }

            p {
                font-size: 14px;
                color: #cbd5e1;
            }
        }
    }
}

.pricing-section {
    background: #f8fafc;

    .pricing-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 32px;
        align-items: stretch;

        .pricing-card {
            background: white;
            border-radius: 24px;
            padding: 32px;
            border: 1px solid #e2e8f0;
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
            transition: all 0.3s;
            display: flex;
            flex-direction: column;
            position: relative;

            &:hover {
                transform: translateY(-16px);
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
            }

            .card-top-accent {
                position: absolute;
                inset-x: 0;
                top: 0;
                height: 8px;
                border-radius: 24px 24px 0 0;
                opacity: 0.5;
                transition: opacity 0.3s;
            }

            .accent-sysA {
                background: #14b8a6;
            }

            .accent-sysB {
                background: #6366f1;
            }

            &:hover .card-top-accent {
                opacity: 1;
            }

            &.featured {
                border: 2px solid #3286c0;
                box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);

                &:hover {
                    box-shadow: 0 25px 50px -12px rgba(59, 130, 246, 0.2);
                }

                .recommended-badge {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    display: flex;
                    justify-content: center;
                    transform: translate(-50%, -50%);

                    span {
                        background: #3286c0;
                        color: white;
                        font-size: 12px;
                        font-weight: 700;
                        padding: 6px 16px;
                        border-radius: 9999px;
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                    }
                }
            }

            &#pricing-sysA {
                border-top: 5px solid #14b8a6;
            }

            &#pricing-sysB {
                border-top: 5px solid #6366f1;
            }

            .card-content {
                margin-bottom: 24px;
                padding-top: 16px;

                .price-badge {
                    display: inline-block;
                    padding: 4px 12px;
                    font-size: 12px;
                    font-weight: 700;
                    border-radius: 9999px;
                }

                .badge-sysA {
                    background: #f0fdfa;
                    color: #115e59;
                    border: 1px solid #ccfbf1;
                }

                .badge-combo {
                    background: #eff6ff;
                    color: #1e40af;
                    border: 1px solid #dbeafe;
                }

                .badge-sysB {
                    background: #eef2ff;
                    color: #3730a3;
                    border: 1px solid #e0e7ff;
                }

                h3 {
                    font-size: 20px;
                    font-weight: 700;
                    color: #0f172a;
                    margin-top: 16px;
                }

                .price-description {
                    font-size: 14px;
                    color: #64748b;
                    margin-top: 8px;
                    height: 40px;
                }
            }

            .price-options {
                background: #f8fafc;
                border-radius: 12px;
                padding: 16px;
                margin-bottom: 24px;

                &.combo-options {
                    background: #eff6ff;
                    border: 1px solid #dbeafe;
                }

                .price-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 14px;
                    margin-bottom: 8px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    span:first-child {
                        color: #475569;
                    }

                    .price {
                        font-weight: 700;
                        color: #0f172a;
                    }

                    .price-brand {
                        color: #1066A9;
                    }

                    .price-large {
                        font-size: 18px;
                    }
                }
            }

            .card-features {
                flex: 1;

                ul {
                    list-style: none;

                    li {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 14px;
                        color: #475569;
                        margin-bottom: 2px;

                        i {
                            width: 16px;
                            height: 16px;
                            flex-shrink: 0;
                            margin-top: 2px;
                        }

                        &.featured-feature {
                            font-weight: 500;
                            color: #1e293b;

                            i {
                                color: #3b82f6;
                            }
                        }
                    }
                }
            }

            .btn-buy {
                width: 100%;
                padding: 14px;
                border-radius: 12px;
                font-weight: 700;
                transition: all 0.3s;
                cursor: pointer;
                border: none;
            }

            .btn-buy-sysA {
                background: #f0fdfa;
                color: #0d9488;
                border: 1px solid #99f6e4;

                &:hover {
                    background: #14b8a6;
                    color: white;
                }
            }

            .btn-buy-combo {
                background: #1066A9;
                color: white;
                box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.3);

                &:hover {
                    background: #115289;
                }
            }

            .btn-buy-sysB {
                background: #eef2ff;
                color: #4f46e5;
                border: 1px solid #c7d2fe;

                &:hover {
                    background: #6366f1;
                    color: white;
                }
            }

            &.highlight-pulse {
                animation: ringPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
            }

            &.pricing-selected-sysB {
                border-color: #6366f1 !important;
                border-width: 2px !important;
                transform: translateY(-16px);
                box-shadow: 0 25px 50px -12px rgba(99, 102, 241, 0.25);
            }

            &.pricing-selected-combo {
                border-color: #1066A9 !important;
                border-width: 3px !important;
                transform: translateY(-16px) scale(1.05);
                box-shadow: 0 25px 50px -12px rgba(16, 102, 169, 0.3);
            }
        }
    }
}

@keyframes ringPulse {
    0% {
        box-shadow: 0 0 0 0px rgba(16, 102, 169, 0.4);
    }

    70% {
        box-shadow: 0 0 0 15px rgba(16, 102, 169, 0);
    }

    100% {
        box-shadow: 0 0 0 0px rgba(16, 102, 169, 0);
    }
}

.selection-guide {
    background: white;
    border-bottom: 1px solid #f1f5f9;
    padding: 64px 80px;

    .guide-title {
        font-size: 20px;
        font-weight: 700;
        color: #0f172a;
        margin-bottom: 24px;
        text-align: center;
    }

    .guide-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px;

        .guide-card {
            padding: 20px;
            border-radius: 16px;
            border: 1px solid #e2e8f0;
            background: #f8fafc;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                border-color: #93c5fd;
                background: #eff6ff;
            }

            &.combo-guide {
                border-color: #bfdbfe;
                background: rgba(239, 246, 255, 0.5);

                &:hover {
                    border-color: #60a5fa;
                    background: #eff6ff;
                }
            }

            h4 {
                font-weight: 700;
                color: #0f172a;
                margin-bottom: 4px;
            }

            .guide-choice {
                font-size: 12px;
                font-weight: 500;
                color: #4f46e5;
                margin-bottom: 12px;

                &.choice-sysA {
                    color: #0d9488;
                }

                &.choice-sysB {
                    color: #4f46e5;
                }

                &.choice-combo {
                    color: #1066A9;
                }
            }

            .guide-desc {
                font-size: 12px;
                color: #64748b;
            }
        }
    }
}

.purchase-process {
    background: #115289;
    color: white;

    .process-steps {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            top: 32px;
            left: 40px;
            right: 40px;
            height: 2px;
            background: #3b82f6;
            z-index: 0;
        }

        .process-step {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            width: 192px;
            position: relative;
            background: #115289;

            .step-icon {
                width: 64px;
                height: 64px;
                border-radius: 9999px;
                background: white;
                border: 4px solid #115289;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 16px;
                color: #1066A9;
                font-weight: 700;
                font-size: 20px;
                box-shadow: 0 0 0 2px rgba(16, 102, 169, 0.5);

                i {
                    width: 24px;
                    height: 24px;
                }
            }

            h4 {
                font-weight: 700;
                margin-bottom: 8px;
            }

            p {
                font-size: 12px;
                color: #bfdbfe;
            }
        }
    }
}

.faq-section {
    background: white;
    padding: 96px 160px;

    .section-title {
        font-size: 30px;
        font-weight: 700;
        color: #0f172a;
        margin-bottom: 48px;

        &.centered {
            text-align: center;
        }
    }

    .faq-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);

        .faq-item {
            margin: 15px 15px;

            h4 {
                display: flex;
                align-items: center;
                font-weight: 700;
                color: #0f172a;
                margin-bottom: 8px;
                display: flex;
                gap: 8px;

                .faq-q {
                    color: #3b82f6;
                }
            }

            p {
                font-size: 14px;
                color: #475569;
                line-height: 1.625;
            }
        }
    }
}

.footer {
    background: #115289;
    padding: 40px 80px;
    position: relative;
    overflow: hidden;
    border-top: 1px solid #1e40af;

    .footer-content {
        position: relative;
        z-index: 10;
        color: #93c5fd;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .footer-left {
            display: flex;
            align-items: center;
            gap: 8px;

            .footer-logo {
                width: 24px;
                height: 24px;
                background: #1066a9;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;

                i {
                    color: #bfdbfe;
                    width: 16px;
                    height: 16px;
                }
            }
        }

        .footer-links {
            display: flex;
            gap: 24px;

            a {
                color: #93c5fd;
                text-decoration: none;
                transition: color 0.3s;

                &:hover {
                    color: white;
                }
            }
        }
    }
}

.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(4px);
    }
}

.modal-content {
    background: white;
    border-radius: 24px;
    position: relative;
    z-index: 10;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    animation: modalSlideUp 0.3s ease-out;
}

@keyframes modalSlideUp {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.purchase-modal {
    width: 580px;
    max-width: 100%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;

    .modal-header {
        padding: 20px 32px;
        border-bottom: 1px solid #f1f5f9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: white;
        flex-shrink: 0;

        h3 {
            font-size: 18px;
            font-weight: 700;
            color: #0f172a;
            display: flex;
            align-items: center;
            gap: 8px;

            i {
                width: 20px;
                height: 20px;
                color: #1066A9;
            }
        }

        .modal-close {
            color: #94a3b8;
            padding: 4px;
            border-radius: 6px;
            transition: all 0.3s;
            background: transparent;
            border: none;
            cursor: pointer;

            &:hover {
                color: #475569;
                background: #f1f5f9;
            }

            i {
                width: 20px;
                height: 20px;
            }
        }
    }

    .modal-tabs {
        padding: 20px 32px 0;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        border-radius: 10px;

        .tab-btn {
            flex: 1;
            padding: 12px;
            font-size: 14px;
            font-weight: 600;
            transition: all 0.3s;
            position: relative;
            color: #64748b;
            background: transparent;
            border: none;
            cursor: pointer;
            background-color: #f8fafc;
            border: 1px solid #e2e8f0;

            &:nth-child(1) {
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
            }

            &:nth-last-child(1) {
                border-top-right-radius: 10px;
                border-bottom-right-radius: 10px;
            }

            &.active {
                color: #1066A9;
                background: white;
                border-left: 1px solid #e2e8f0;
                border-right: 1px solid #e2e8f0;
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
            }

            .tab-badge {
                position: absolute;
                top: -2px;
                left: 50%;
                transform: translateX(-50%);
                background: #3b82f6;
                color: white;
                font-size: 9px;
                font-weight: 700;
                padding: 2px 8px;
                border-radius: 9999px;
                line-height: 1;
            }
        }
    }

    .modal-body {
        padding: 20px 32px;
        overflow-y: auto;
        flex: 1;

        .purchase-page {
            .plan-card {
                border-radius: 16px;
                padding: 24px;

                &.plan-sysA {
                    border: 2px solid #e2e8f0;
                }

                &.plan-combo {
                    border: 2px solid #93c5fd;
                }

                &.plan-sysB {
                    border: 2px solid #e2e8f0;
                }

                .plan-badge {
                    display: inline-block;
                    padding: 4px 12px;
                    font-size: 12px;
                    font-weight: 700;
                    border-radius: 9999px;
                    margin-bottom: 12px;
                }

                .badge-sysA {
                    background: #f0fdfa;
                    color: #115e59;
                    border: 1px solid #ccfbf1;
                }

                .badge-combo {
                    background: #eff6ff;
                    color: #1e40af;
                    border: 1px solid #dbeafe;
                }

                .badge-sysB {
                    background: #eef2ff;
                    color: #3730a3;
                    border: 1px solid #e0e7ff;
                }

                h4 {
                    font-size: 20px;
                    font-weight: 700;
                    color: #0f172a;
                    margin-bottom: 8px;
                }

                .plan-desc {
                    font-size: 14px;
                    color: #64748b;
                    margin-bottom: 16px;
                    line-height: 1.625;
                }

                .plan-features {
                    list-style: none;

                    li {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 14px;
                        color: #475569;

                        i {
                            width: 16px;
                            height: 16px;
                            flex-shrink: 0;
                        }
                    }
                }

                .duration-label {
                    font-size: 12px;
                    font-weight: 600;
                    color: #334155;
                    margin-bottom: 12px;
                }

                .duration-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 12px;

                    &.duration-grid-5 {
                        grid-template-columns: repeat(3, 1fr);

                        button:nth-child(4),
                        button:nth-child(5) {
                            grid-column: span 1;
                        }
                    }

                    .duration-btn {
                        padding: 12px;
                        border-radius: 12px;
                        border: 2px solid #e2e8f0;
                        text-align: center;
                        transition: all 0.3s;
                        cursor: pointer;
                        background: transparent;

                        &:hover {
                            border-color: #93c5fd;
                        }

                        &.selected {
                            border-color: #3b82f6;
                            background: #1066A9;
                            color: white;

                            .duration-label-small {
                                opacity: 0.8;
                                color: white;
                            }

                            .duration-price {
                                font-weight: 700;
                                color: white;
                            }
                        }

                        .duration-label-small {
                            font-size: 12px;
                            color: #64748b;
                            margin-bottom: 2px;
                        }

                        .duration-price {
                            font-weight: 700;
                            font-size: 16px;
                            color: #0f172a;
                            margin-top: 10px;
                        }
                    }
                }
            }
        }

        .page-nav {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            font-size: 14px;
            color: #64748b;

            button {
                display: flex;
                align-items: center;
                gap: 4px;
                padding: 4px 8px;
                border-radius: 8px;
                color: #64748b;
                transition: all 0.3s;
                cursor: pointer;
                background: transparent;
                border: none;

                &:hover:not(:disabled) {
                    color: #1066A9;
                    background: #f0f6fa;
                }

                &:disabled {
                    opacity: 0.3;
                    pointer-events: none;
                }

                i {
                    width: 16px;
                    height: 16px;
                }
            }

            .page-indicator {
                font-weight: 500;
            }
        }
    }

    .modal-footer {
        padding: 20px 32px;
        border-top: 1px solid #f1f5f9;
        background: #f8fafc;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .summary {
            .summary-text {
                font-size: 12px;
                color: #64748b;
                margin-bottom: 2px;

                .summary-plan,
                .summary-duration {
                    font-weight: 500;
                    color: #334155;
                }
            }

            .summary-price {
                font-size: 24px;
                font-weight: 800;
                color: #1066A9;

                .price-unit {
                    font-size: 14px;
                    font-weight: 400;
                    color: #94a3b8;
                }
            }
        }

        .btn-submit {
            background: #1066A9;
            color: white;
            font-weight: 700;
            padding: 14px 32px;
            border-radius: 12px;
            box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.3);
            transition: all 0.3s;
            border: none;
            cursor: pointer;

            &:hover {
                background: #115289;
                transform: translateY(-2px);
            }
        }
    }

    .agreement-text {
        text-align: center;
        font-size: 12px;
        color: #94a3b8;
        padding: 12px;

        a {
            color: #1066A9;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}

.payment-modal {
    width: 420px;

    .modal-header {
        padding: 20px 28px;
        border-bottom: 1px solid #f1f5f9;
        display: flex;
        justify-content: space-between;
        align-items: center;

        h3 {
            font-size: 18px;
            font-weight: 700;
            color: #0f172a;
        }

        .order-info {
            font-size: 12px;
            color: #94a3b8;
            margin-top: 2px;

            .order-summary {
                color: #475569;
                font-weight: 500;
            }
        }

        .modal-close {
            color: #94a3b8;
            padding: 4px;
            border-radius: 6px;
            transition: all 0.3s;
            background: transparent;
            border: none;
            cursor: pointer;

            &:hover {
                color: #475569;
                background: #f1f5f9;
            }

            i {
                width: 20px;
                height: 20px;
            }
        }
    }

    .payment-methods {
        display: flex;
        padding: 20px 28px 0;

        .method-tab {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 10px;
            margin: 0 5px;
            border-radius: 12px;
            border: 2px solid #e2e8f0;
            font-weight: 600;
            font-size: 14px;
            transition: all 0.3s;
            cursor: pointer;
            background: transparent;

            &.active {
                border-color: #3b82f6;
                background: #eff6ff;
                color: #1e40af;
            }

            &:not(.active) {
                color: #64748b;

                &:hover {
                    border-color: #4ade80;
                    color: #16a34a;
                }
            }

            svg {
                width: 20px;
                height: 20px;
            }

            .icon-alipay {
                fill: #3b82f6;
            }

            .icon-wechat {
                fill: #22c55e;
            }
        }
    }

    .payment-content {
        padding: 20px 28px;
        text-align: center;

        .payment-amount {
            font-size: 30px;
            font-weight: 800;
            color: #1066A9;
            margin-bottom: 4px;
        }

        .payment-timer {
            font-size: 12px;
            color: #94a3b8;
            margin-bottom: 20px;

            .timer-text {
                color: #ef4444;
                font-weight: 600;
            }
        }

        .qr-code-placeholder {
            width: 192px;
            height: 192px;
            margin: 0 auto 16px;
            border-radius: 16px;
            border: 2px dashed #e2e8f0;
            background: #f8fafc;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #94a3b8;

            i {
                width: 64px;
                height: 64px;
                margin-bottom: 8px;
                color: #cbd5e1;
            }

            span {
                font-size: 12px;
            }
        }

        .payment-tip {
            font-size: 12px;
            color: #94a3b8;
        }
    }

    .payment-actions {
        padding: 0 28px 28px;
        display: flex;
        flex-direction: column;
        gap: 12px;

        .btn-confirm {
            width: 100%;
            background: #1066A9;
            color: white;
            font-weight: 700;
            padding: 14px;
            border-radius: 12px;
            box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.3);
            transition: all 0.3s;
            border: none;
            cursor: pointer;

            &:hover {
                background: #115289;
            }
        }

        .btn-cancel {
            width: 100%;
            padding: 12px;
            border-radius: 12px;
            border: 1px solid #e2e8f0;
            color: #64748b;
            font-weight: 500;
            transition: all 0.3s;
            cursor: pointer;
            background: transparent;
            font-size: 14px;

            &:hover {
                background: #f8fafc;
                color: #334155;
            }
        }
    }
}

.login-modal {
    width: 420px;

    .login-tabs {
        display: flex;
        font-size: 16px;
        height: 56px;
        background: #f8fafc;
        position: relative;

        .tab {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            &.active {
                color: #1066A9;
                font-weight: 500;
                background: white;
                border-top-right-radius: 16px;
                position: relative;
                z-index: 10;

                &::after {
                    content: '';
                    position: absolute;
                    right: -12px;
                    bottom: 0;
                    width: 12px;
                    height: 12px;
                    background: white;

                    &::before {
                        content: '';
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        background: #f8fafc;
                        border-radius: 0 0 100% 0;
                    }
                }
            }

            &.disabled {
                color: #64748b;
                cursor: not-allowed;
                font-size: 14px;
            }
        }

        .modal-close {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #94a3b8;
            padding: 4px;
            border-radius: 6px;
            transition: all 0.3s;
            background: transparent;
            border: none;
            cursor: pointer;
            z-index: 20;

            &:hover {
                color: #475569;
                background: #e2e8f0;
            }

            i {
                width: 20px;
                height: 20px;
            }
        }
    }

    .login-form {
        padding: 32px;
        padding-top: 24px;

        .input-phone {
            width: 100%;
            padding: 14px 16px;
            color: #0f172a;
            border-radius: 12px;
            border: 1px solid #e2e8f0;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 500;
            transition: all 0.3s;
            outline: none;

            &::placeholder {
                color: #94a3b8;
            }

            &:focus {
                border-color: #3b82f6;
                box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
            }
        }

        .input-group {
            display: flex;
            gap: 12px;
            margin-bottom: 32px;

            .input-code {
                flex: 1;
                padding: 14px 16px;
                color: #0f172a;
                border-radius: 12px;
                border: 1px solid #e2e8f0;
                font-size: 16px;
                transition: all 0.3s;
                outline: none;

                &::placeholder {
                    color: #94a3b8;
                }

                &:focus {
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
                }
            }

            .btn-get-code {
                padding: 14px 20px;
                border: 1px solid #3b82f6;
                color: #1066A9;
                border-radius: 12px;
                white-space: nowrap;
                transition: all 0.3s;
                cursor: pointer;
                background: transparent;
                font-weight: 500;

                &:hover {
                    background: #eff6ff;
                }
            }
        }

        .btn-login {
            width: 100%;
            background: #1e78c2;
            color: white;
            padding: 14px;
            border-radius: 12px;
            font-weight: 500;
            transition: all 0.3s;
            font-size: 18px;
            box-shadow: 0 4px 6px -1px rgba(30, 120, 194, 0.1);
            border: none;
            cursor: pointer;

            &:hover {
                background: #15609e;
            }
        }

        .login-agreement {
            font-size: 12px;
            text-align: center;
            color: #94a3b8;
            margin-top: 24px;
            line-height: 1.625;

            a {
                color: #1066A9;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}

/* 图标样式占位符 - 实际使用时需要引入图标库 */
.icon-monitor,
.icon-file-check,
.icon-cpu,
.icon-laptop,
.icon-check-circle,
.icon-arrow-right,
.icon-image,
.icon-target,
.icon-box,
.icon-list-checks,
.icon-activity,
.icon-sliders,
.icon-repeat,
.icon-git-merge,
.icon-alert-triangle,
.icon-heart-pulse,
.icon-hourglass,
.icon-file-x,
.icon-database,
.icon-ruler,
.icon-layers,
.icon-file-text,
.icon-sparkles,
.icon-file-check,
.icon-check,
.icon-piggy-bank,
.icon-shield-check,
.icon-git-pull-request,
.icon-files,
.icon-message-square-check,
.icon-monitor-smartphone,
.icon-shopping-cart,
.icon-log-in,
.icon-mouse-pointer,
.icon-play-circle,
.icon-line-chart,
.icon-cross,
.icon-x,
.icon-chevron-left,
.icon-chevron-right,
.icon-qr-code,
.icon-user,
.icon-logout,
.icon-arrow-down,
.icon-check-circle-2 {
    display: inline-block;
    width: 1em;
    height: 1em;
    vertical-align: middle;
}

/* 响应式调整（可选） */
@media (max-width: 1440px) {
    .app-container {
        width: 100%;
        min-width: auto;
    }

    .glass-header {
        width: 100%;
        left: 0;
        transform: none;
    }
}
</style>